const ENV = Shopify.shop.includes('morgans-dont-run-out') ? "prod" : "staging";

const MEMBERSHIP_PRODUCT_IDS = {
  prod: +window.theme.settings.membership_product_prod,
  staging: +window.theme.settings.membership_product_staging
}

const MEMBERSHIP_VARIANT_IDS = {
  prod: +window.theme.settings.membership_variant_prod,
  staging: +window.theme.settings.membership_variant_staging
};

const SELLING_PLAN_IDS = {
  prod: +window.theme.settings.membership_product_selling_prod,
  staging: +window.theme.settings.membership_product_selling_staging
};

let hasRun = true
if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);
        } else {
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);
      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//********************* Wine SKU global ****************

//       Pack wine SKU with single SKU and quantity
const wineVariantIdSku = {

  "032-310-001-201":[{sku: "032-110-002-001", qty:1},{sku: "032-310-001-001", qty:1}, {sku: "032-110-001-001", qty:1}], //White variety 3pc
  "032-210-001-101":[{sku: "032-210-001-001", qty:3}], //Rosé  3pc
  "032-010-001-101":[{sku: "032-010-001-001", qty:3}], //Red Blend  3pc
  "032-010-001-201":[{sku: "032-010-001-001", qty:1},{sku: "032-110-002-001", qty:1},{sku: "032-210-001-001", qty:1}], //Red & Rosé 3pc
  "032-310-001-101":[{sku: "032-310-001-001", qty:3}], //Prosecco  3pc
  "032-110-001-101":[{sku: "032-110-001-001", qty:3}], //Pinot Grigio  3pc
  "032-010-002-101":[{sku: "032-010-002-001", qty:3}], //Malbec  3pc
  "032-110-002-101":[{sku: "032-110-002-001", qty:3}], //Chardonnay  3pc

  "032-000-008-011":[{sku: "032-110-002-001", qty:6}], //Chardonnay 6pc
   "032-000-006-011":[{sku: "032-010-002-001", qty:6}],//Malbec 6pc
   "032-000-004-011":[{sku: "032-210-001-001", qty:3},{sku: "032-310-001-001", qty:3}],
   "032-000-007-011":[{sku: "032-110-001-001", qty:6}], //Pinot Grigio 6pc
   "032-000-010-011":[{sku: "032-310-001-001", qty:6}], //Prosecco 6pc
   "032-000-005-011":[{sku: "032-010-001-001", qty:6}], //red blend 6pc
   "032-000-002-011":[{sku: "032-010-001-001", qty:3},{sku: "032-010-002-001", qty:3}], //red variaty
   "032-000-009-011":[{sku: "032-210-001-001", qty:6}],  //rose 6pc
   "032-000-001-011":[{sku: "032-010-001-001", qty: 1},{sku: "032-010-002-001", qty:1},{sku: "032-110-002-001", qty:1},{sku: "032-110-001-001", qty:1},{sku: "032-310-001-001", qty:1},{sku: "032-210-001-001", qty:1}],
   "032-000-003-011":[{sku: "032-110-001-001", qty:3},{sku: "032-110-002-001", qty:3}],
    "032-000-019-011":[{sku:"032-110-002-001",qty:12}], // //Chardonnay 12pc
   "032-000-017-011":[{sku:"032-010-002-001",qty:12}],  //Malbec 12pc
   "032-000-016-011":[{sku:"032-210-001-001",qty:6},{sku:"032-310-001-001",qty:6}], // Party 12pc
   "032-000-018-011":[{sku:"032-110-001-001",qty:12}], //Pinot Grigio 12pc
   "032-000-021-011":[{sku:"032-310-001-001",qty:12}], //Prosecco 12pc
   "032-000-022-011":[{sku:"032-010-001-001",qty:12}], //Red blend 12pc
   "032-000-014-011":[{sku:"032-010-001-001",qty: 6},{sku:"032-010-002-001",qty:6}], //red variety 12pc
   "032-000-020-011":[{sku:"032-210-001-001",qty:12}], //Rose 12pc
   "032-000-012-011":[{sku:"032-110-002-001",qty:2},{sku:"032-110-001-001",qty:2},{sku:"032-210-001-001",qty:2},{sku:"032-310-001-001",qty:2},{sku:"032-010-002-001",qty:4}], //variety 12pc
   "032-000-015-011":[{sku:"032-110-001-001",qty:6},{sku:"032-110-002-001",qty:6}] //white variety 12pc
 };



theme.ariaToggleSlide = function() {
  $(document).on('click', '.ariaToggleSlide', function(event) {
    event.preventDefault();
    var $currentTarget = $(event.currentTarget);
    $currentTarget.attr('aria-expanded', $currentTarget.attr('aria-expanded')=='false' ? 'true' : 'false');
    var toggleID = $currentTarget.attr('aria-controls');
    $( '#'+ toggleID ).slideToggle();
  });
};

// ***** Move collection CTA on mobile to hover over image *******

theme.moveCollectionCtaMobile = function() {
  if (window.innerWidth > 1007 && !document.URL.includes("/products")) {
    document.querySelectorAll('.ProductCard').forEach(function(card) {
      const imageWrapper = card.querySelector('.ProductCard__ImageWrapper');
      const atcButton = card.querySelector('.ProductCard__AddToCart');

      if (imageWrapper && atcButton) {
        imageWrapper.appendChild(atcButton);
        atcButton.style.display = 'none'; // hide by default

        // Show on hover
        card.addEventListener('mouseenter', () => {
          atcButton.style.display = 'block';
        });

        card.addEventListener('mouseleave', () => {
          atcButton.style.display = 'none';
        });
      }
    });
  }
}

// ********************* Product reviews slider **********************

theme.canceledMember = function() {

  // if user if not customer or isn't allow to shop, show pop-up for options
    if (failedAnnualPayment == true) {
      $('#payment-failed-pop-up-wrapper').length && $('#payment-failed-pop-up-wrapper').css('display', 'block')
      let popupWidth = (window.innerWidth - $('#payment-failed-pop-up-wrapper').width()) / 2
      $('#payment-failed-pop-up-wrapper').css('right', popupWidth )
      sessionStorage.setItem("pgCanceledMember", "true")
    } else {
      // $('#reactivate-pop-up-wrapper').css('display', 'block')
      // $('html').addClass('no-scroll');
      // let popupWidth = (window.innerWidth - $('#reactivate-pop-up-wrapper').width()) / 2
      // $('#reactivate-pop-up-wrapper').css('right', popupWidth )
    }
}


//*********************** Scroll banner stickyi dynamic************ */

theme.scrollBannerAdjust = function () {
  if(window.location.pathname == '/' ){
    const headerHeight = $('header.Header').innerHeight();
    $('.ScrolledBlocks__Item').css('top',headerHeight + 'px')
  }
}

//********************* Tabs function *****************

theme.tabsFunction =  function (container, button, content) {
  var $tabsContainer = $(container);
  var $tabButton = $tabsContainer.find(button);

  $tabButton.on('click', function () {
    var index = $(this).index();
    var $tab = $(container).find(content);

    if (!$(this).hasClass('Active')) {
      $tabButton.removeClass('Active');
      $(this).addClass('Active');
      $tab.hide().eq(index).fadeIn();
    }
  });
}


//Check URL contains para

theme.urlContains = function(param) {
  return document.location.href.indexOf(param) > -1 ? true : false;
}


//**********************Convert Time************************************* */
// theme.convertToEstTimeZone = function (date) {// function to connvert date object to EST
//   //EST offset
//   const offset = -4
//   // date passed from param
//   const clientDate = date;
//   // convert Date into UTC time
//   const utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000);
//   // convert to EST
//   const timeInEst = new Date(utc + (3600000 * offset));
//   // return date object
//   return timeInEst;
// }

//************* EST Time Converter ************************** */
// theme.createStartEndTime = function (startDate, endDate) {
//   const startTime = new Date(startDate);
//   const endTime = new Date(endDate);

//   // convert start time and end time to EST
//   const showBannerTimeDateObj = theme.convertToEstTimeZone(startTime);
//   const hideBannerTimeDateObj = theme.convertToEstTimeZone(endTime);
//   const bannerTimes = {start: showBannerTimeDateObj, end:hideBannerTimeDateObj};
//   return bannerTimes;
// }

function setCookie(name, value, days, domain) {
  let expires = "";
  if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }
  // Set domain if provided, otherwise leave it out
  const domainPart = domain ? `; domain=${domain}` : "";
  // Encode cookie value for special characters
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}${domainPart}; path=/`;
}

//*********************** Listerner for cart object change***************

theme.listenCartObjChange = function() {
    const open = window.XMLHttpRequest.prototype.open;
    let errorAddingFreeProduct = false;

  function openReplacement() {
    this.addEventListener("load", function () {
      if (
        [
          "/cart/add.js",
          "/cart/update.js",
          "/cart/change.js",
          "/cart/clear.js",
        ].includes(this._url)
      ) {
        promoCheck(JSON.parse(this.response));
      }
    });
    return open.apply(this, arguments);
  }

  window.XMLHttpRequest.prototype.open = openReplacement;

  (function(ns, fetch) {
      if (typeof fetch !== 'function') return;

      ns.fetch = function() {
          const response = fetch.apply(this, arguments);

          response.then(res => {
              if ([
                      `${window.location.origin}/cart/add.js`,
                      `${window.location.origin}/cart/update.js`,
                      `${window.location.origin}/cart/change.js`,
                      `${window.location.origin}/cart/clear.js`,
                  ].includes(res.url)) {
                  res.clone().json().then(data => {
                    promoCheck(data);
                  });
              }
          });

          return response;
      }

  }(window, window.fetch));
}

async function promoCheck(cartJson) {
   // let cartTotalPrice = parseInt($('#Cart__TotalPrice').data('cartTotalPrice'))/100;
  let promoThreshold = window.cartFreeGiftThreshold / 100
  const promoProductId = window.gwpProduct.variant_id ? window.gwpProduct.variant_id : null;
  // Check cart for multipl free items
  let freeItemIds = [];

  if (cartJson.items) {
    for (let item of cartJson.items) {
      if (item.original_price === 0 && item.quantity > 1) {
        freeItemIds.push(item.variant_id)
      }
    }
    if (freeItemIds.length > 0) {
      for (let itemId of freeItemIds) {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: {
            id: itemId,
            quantity: 1
          },
          success: function(res) {
            window.location.href.indexOf('cart') > -1 && theme.rerenderCartPageBody();
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
          },
          error: function (request, status, error) {
              console.log(request.responseText);
          }
        })
      }
    }
  }
  // End free titem check

  if (!promoProductId) return; 
  let offerItemRemoved = cartJson.items_removed && cartJson.items_removed[0].title.includes("Offer")
    
  if(!window.cartShowFreeShippingThreshold || offerItemRemoved) return;
  const response = await fetch('/?sections[]=get-member-cart-total');
  const result = await response.json();
  const itemsToChange = JSON.parse((result['get-member-cart-total'] || '').replace(/<[^>]*>?/gm, ''));
  if (itemsToChange == false) return;
  const memberTotal = itemsToChange / 100
  // $('#CartLoading').show();

   $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: "json",
      success: function(res) {
        // $('#CartLoading').hide();
        window.location.href.indexOf('cart') > -1 && theme.rerenderCartPageBody();
        const promoProduct = res.items.find(item => {return item.id == promoProductId});
        const promoInCart = promoProduct? true : false;
        let promoQuantity = 0;
        if (promoInCart) { promoQuantity = promoProduct.quantity }
        const membershipInCart = res.items.find(item => {return item.product_id == MEMBERSHIP_PRODUCT_IDS[ENV]})
        let totalPrice = parseInt(res.total_price)/100;

        if (!window.activeMember && membershipInCart) {
          totalPrice = memberTotal
        }

        if(sessionStorage.getItem('removeCartPromo') || localStorage.getItem('country_code') === 'CA')
          return;

        if(totalPrice > promoThreshold && !promoInCart){
          let data = {
            id: promoProductId,
            quantity: 1
          };
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data,
            success: function(res) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
            },
            error: function (request, status, error) {
                console.log('Adding free promo error, (Ignore if Dev Or Stag)::',request.responseText);
                errorAddingFreeProduct = true;
            }
          })
        } else if(totalPrice < promoThreshold && promoInCart) {
          let data = {
              id: promoProductId,
              quantity: 0
            };
            $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: data,
            success: function(res) {
              window.location.href.indexOf('cart') > -1 && theme.rerenderCartPageBody();
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
            },
            error: function (request, status, error) {
                console.log(request.responseText);
            }
          })
        }
      }
    })
}


// ********************* Update Memebership Status - isVariation is used when there is a competing membership option we are testing **********************
theme.resetMembership = function (isVariation) {
  let updates = {};
  if (isVariation) {
    sessionStorage.setItem('Membership Option', 'Annual 69 No Trial');
    updates = { 'attributes[Membership Option]': 'Annual 69 No Trial' };
  } else {
    sessionStorage.setItem('Membership Option', 'Annual 65 No Trial free shipping');
    updates = { 'attributes[Membership Option]': '' };
  }
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: updates,
    success: function (cart) {
      // addProductToCartOnce([45738121298058]);
      // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      // theme.rerenderCartPageBody();
      for (let item of cart.items) {
        // no trial 49 membership
        if (item.variant_id === 45440292225162) {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                id: 45440292225162,
                quantity: 0
            },
            success: function () {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
            },
            error: function (error) {
              if (error.status == 422) {
                console.log(error.responseJSON.description);
              }
            }
          });
        }
      }
    },
    error: function (error) {
      console.error('Error resetting membership cart attribute status:', error);
    }
  });

}

function addProductToCartOnce(productIds, sellingPlan) {
  if (activeMember) return;

  let variantIds = Object.keys(Shopify.cartItems);

  let productsToAdd = productIds.filter(productId => !variantIds.includes(productId.toString()));

  let items = []

  if (productsToAdd.length > 0) {
    for (id of productsToAdd) {
      items.push({'id': id, 'quantity': 1, 'selling_plan': sellingPlan})
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { items },
      success: function (data) {
        window.membershipInCart = true;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        theme.rerenderCartPageBody();
      },
      error: function (error) {
        reject(error);
      }
    });
  }
}

function handleProductRemoval(variantIds) {

  let cartItemIds = Object.keys(Shopify.cartItems);

  let productsToRemove = variantIds.filter(variantId => cartItemIds.includes(variantId.toString()));

  if (productsToRemove.length === 0) return;

  let updates = variantIds.reduce((acc, id) => {
    acc[id] = 0
    return acc
  },{})

   $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: { updates },
      success: function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      },
      error: function (error) {
        console.error('Error removing product from cart:', error);
      }
    });
}
// ***** Function below is for the membership selection page that is no longer in use
// theme.updateMembershipStatus = function () {
//   const monthlyOption = sessionStorage.getItem('Membership Option');

//   function attachResetMembershipListener() {
//     const resetMembershipButtons = document.querySelectorAll('[data-reset-membership-status]');
//     resetMembershipButtons.forEach(button => {
//       if (!button.dataset.listenerAttached) {
//         button.addEventListener('click', function (e) {
//           e.preventDefault();
//           theme.resetMembership(localStorage.getItem('isVariation') || false);
//         });
//         button.dataset.listenerAttached = true;
//       }
//     });
//   }

//   function observeDOMChanges() {
//     const observer = new MutationObserver(function (mutations) {
//       mutations.forEach(function (mutation) {
//         if (mutation.type === 'childList' || mutation.type === 'attributes') {
//           attachResetMembershipListener();
//         }
//       });
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
//   }

//   function updateCartAttributes(updates, callback) {
//     $.ajax({
//       type: 'POST',
//       url: '/cart/update.js',
//       dataType: 'json',
//       data: updates,
//       success: function () {
//         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
//         if (window.location.href.indexOf('/pages/cart') > -1) { theme.rerenderCartPageBody(); }
//         attachResetMembershipListener();
//         if (callback) callback();
//       },
//       error: function (error) {
//         console.error('Error updating membership cart attribute status:', error);
//       }
//     });
//   }


//   const membershipUpdateButtons = document.querySelectorAll('[data-membership-update]');
//   if (membershipUpdateButtons.length > 0) {
//     membershipUpdateButtons.forEach(button => {
//       button.addEventListener('click', function (e) {
//         e.preventDefault();
//         let updates = {};
//         const membershipUpdate = this.dataset.membershipUpdate;

//         if (membershipUpdate === "Monthly 11.95") {
//           sessionStorage.setItem('Membership Option', 'Monthly 11.95');
//           updates = { 'attributes[Membership Option]': 'Monthly 11.95' };
//           handleProductRemoval([43538926600330]);
//           updateCartAttributes(updates);
//         } else if (membershipUpdate === "Annual Bundle") {
//           sessionStorage.setItem('Membership Option', 'Annual Bundle');
//           updates = { 'attributes[Membership Option]': 'Annual Bundle' };

//           updateCartAttributes(updates, function () {
//             addProductToCartOnce([43538926600330]);
//           });

//         } else if (membershipUpdate === "14-Day Trial") {
//           theme.resetMembership(localStorage.getItem('isVariation') || false);
//           handleProductRemoval([43538926600330]);
//           return;
//         } else if (membershipUpdate === "Annual No Trial") {
//           sessionStorage.setItem('Membership Option', 'Annual No Trial');
//           updates = { 'attributes[Membership Option]': 'Annual No Trial' };
//           handleProductRemoval([43538926600330]);
//           updateCartAttributes(updates);
//           return;
//         } else {
//           updateCartAttributes(updates);
//         }
//       });
//     });
//   }

//   attachResetMembershipListener();
//   observeDOMChanges();
//   theme.updateCartAttributes = updateCartAttributes;

  function updateCartAttributes(updates, callback) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        dataType: 'json',
        data: updates,
        success: function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
          if (window.location.href.indexOf('/pages/cart') > -1) { theme.rerenderCartPageBody(); }
          attachResetMembershipListener();
          if (callback) callback();
          resolve()
        },
        error: function (error) {
          reject(error);
          console.error('Error updating membership cart attribute status:', error);
        }
      });
    })
  }

// DEPRECATED - Initialize membership option - current default membership
// theme.initializeMembershipOption = function() {

//   localStorage.removeItem('isVariation') // default to Free trial - test is over

//   const membershipOption = sessionStorage.getItem('Membership Option');
//   const isVariation = localStorage.getItem('isVariation') || false;
//   const isFirstTime = !sessionStorage.getItem('hasVisited'); // True if 'hasVisited' doesn't exist

//   sessionStorage.setItem('hasVisited', 'true');

//   if (isFirstTime) return;

//   if (membershipOption !== 'None') {
//     if (!isVariation) {
//       sessionStorage.setItem('Membership Option', 'Annual 65 No Trial free shipping');
//       addProductToCartOnce([45782062858378], 1607729292);
//     } else {
//       sessionStorage.setItem('Membership Option', 'Annual 69 No Trial');
//       addProductToCartOnce([45782062858378], 1607729292);
//     }
//   }
// }

// ********************* Attach landing URL to cart object **********************
theme.attachLandingURL = function () {
  if(!localStorage.getItem('landing_url')) {
    const currentLocation = window.location.href;

    localStorage.setItem('landing_url',currentLocation);
    $.ajax({
      type: "POST",
      url: "/cart.js",
      data: { attributes: { landing_url: currentLocation } },
      dataType: "json",
      success: function (data) {
        //do nothing
        // console.log("Cart after attached Landing URL:: ",data);
      },
      error: function (error) {
        console.log("Adding Landing URL to cart object Error status: ",error.status);
      }
    });
  }
}

// *********** Remove membership from cart **************
theme.removeMembershipProduct = function () {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: "json",
    success: function(res) {
      for (let item of res.items) {
        if (item.variant_id === 44476856598666) {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                id: 44476856598666,
                quantity: 0
            },
            success: function () {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
            },
            error: function (error) {
              if (error.status == 422) {
                console.log(error.responseJSON.description);
              }
            }
          });
        }
        if (item.variant_id === 45178169950346) {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                id: 45178169950346,
                quantity: 0
            },
            success: function () {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
            },
            error: function (error) {
              if (error.status == 422) {
                console.log(error.responseJSON.description);
              }
            }
          });
        }
        // no trial membership
        if (item.variant_id === 44793343541386) {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                id: 44793343541386,
                quantity: 0
            },
            success: function () {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
            },
            error: function (error) {
              if (error.status == 422) {
                console.log(error.responseJSON.description);
              }
            }
          });
        }

        // no trial 49 membership
        if (item.variant_id === 45440292225162) {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                id: 45440292225162,
                quantity: 0
            },
            success: function () {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
            },
            error: function (error) {
              if (error.status == 422) {
                console.log(error.responseJSON.description);
              }
            }
          });
        }
        // makes sure to update product id here with production membership id
        if (item.variant_id === MEMBERSHIP_VARIANT_IDS[ENV]) {
          const data = {
            updates: {
              [MEMBERSHIP_VARIANT_IDS[ENV]]: 0  
          }
        };
        
        if (window.membershipFreeGift) {
          data.updates[45516107645066] = 0;  
        }

          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            dataType: 'json',
            data: data,
            success: function () {
              window.membershipInCart = false
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
              theme.rerenderCartPageBody()
            },
            error: function (error) {
              if (error.status == 422) {
                console.log(error.responseJSON.description);
              }
            }
          });
        }
      }
    }
  })
  sessionStorage.setItem('Membership Option', 'None');
}

//*********************** Remove item from Cart drawer ************************* */
theme.removeCartItem = function () {
  $(document).on("click", ".CartItem__Remove", function (evt) {
    evt.preventDefault();

    const productId = evt.target.getAttribute("data-product-id");
    const itemType = $(evt.target).data("itemType");
    const currentItem = evt.target.getAttribute("data-variant-id");
    const $clickedButton = $(evt.target);
    const parent = $clickedButton.parent();
    const loadingSpinner = parent.find("#loading-spinner");
    const cartItem = parent.parent();
    const mainQty = $(`form[data-productid=${productId}] #quantity_value`);
    const mainQtySelector = $(`form[data-productid=${productId}] .QuantitySelector`);

    loadingSpinner.css("display", "flex");
    cartItem.css('pointer-events', 'none');
    $clickedButton.css("display", "none");
    theme.enableDisableElements(true);

    // if (itemType === "promo") {
    //   $(".only-one-promo").hide();
    //   sessionStorage.setItem("removeCartPromo", "true");
    // } else {
    //   sessionStorage.removeItem("removeCartPromo");
    // }

    const data = {
      id: currentItem,
      quantity: 0,
    };

    function resetUI() {
      loadingSpinner.css("display", "none");
      cartItem.css('pointer-events', 'auto');
      theme.enableDisableElements(false);
    }

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: data,
      success: function (cart) {
        if (currentItem === "40149890760844") {
          theme.resetMembership(localStorage.getItem('isVariation') || false);
        }

        if (itemType === "promo" && sessionStorage.getItem("FreeShippingPromo")) {
          sessionStorage.removeItem("FreeShippingPromo");
        }

        // Update quantity on PDP
        if (location.href.indexOf('/products') > 0) {
          mainQty.val(0).trigger('change');
          mainQtySelector.attr('aria-hidden', 'true');
        }

        theme.syncSameProducts(data.id, 0);
        theme.rerenderCartPageBody();
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));

        resetUI();

        promoCheck(cart)
      },
      error: function (error) {
        console.log(error.responseJSON.description);
      }
    });
  });
}

//*********************** Reinit Cart Recommendations In Cart Drawer ************************* */
theme.reinitializeCartRecommendations = function () {

  const flickityContainers = document.querySelectorAll('.CartRecommended__Slideshow');
  flickityContainers.forEach(function(container) {
      const configString = container.getAttribute('data-flickity-config');
      const parsedConfig = JSON.parse(configString.replace(/&quot;/g, '"'));
      new Flickity(container, parsedConfig);
  });
}

// Check url for free gift parameter and set session storage
theme.checkUrlForFreeGift= function() {
  const freeGift = window.location.search.includes('MembershipUpsell');
  if (freeGift) {
    sessionStorage.setItem('FreeGift', freeGift);
  }
  if (sessionStorage.getItem('FreeGift')) {
    window.membershipFreeGift = true;
  } else {
    window.membershipFreeGift = false;
  }
}

//*********************** Update member/non-member pricing ************************* */
theme.updateProductMemberPrice = function() {

  function enableDisableElements(loading) {
    const checkoutButton = document.getElementById('continue_checkout');
    const drawerCheckoutButton = document.getElementById('Cart__Drawer--checkout-button');
    const loadingCheckoutButton = document.getElementsByClassName('continue_checkout_loading');
    const backToStoreButton = document.getElementById('back_to_store');

    [checkoutButton, drawerCheckoutButton, backToStoreButton].forEach(button => {
      if (button) {
        button.disabled = loading;
        button.style.display = loading ? 'none' : 'block';
      }
    });

    for (button of loadingCheckoutButton) {
      button.style.display = loading ? 'block' : 'none';
    }

    const radios = document.querySelectorAll('input[name="price_option"]');
    radios.forEach(radio => radio.disabled = loading);
  }

  function attachToggleEventListeners() {
    theme.waitForElm('.toggle-member-prices').then(target => {
      if (target) {
        const membershipToggleSections = document.querySelectorAll('.toggle-member-prices');

        function syncToggleState() {
          $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(res) {
              // makes sure to update product id here with production membership id
              const isMemberProductInCart = res.items.some(item => item.product_id === MEMBERSHIP_PRODUCT_IDS[ENV]);

              membershipToggleSections.forEach(section => {
                const memberOption = section.querySelector('input[name="price_option"][value="member"]');
                const nonMemberOption = section.querySelector('input[name="price_option"][value="non-member"]');

                if (isMemberProductInCart) {
                  memberOption.checked = true;
                } else {
                  nonMemberOption.checked = true;
                }
              });
            },
            error: function(error) {
              console.error('Failed to fetch cart contents:', error);
            }
          });
        }

        syncToggleState();

        membershipToggleSections.forEach(section => {
          section.querySelectorAll('input[name="price_option"]').forEach(function(radio) {
            radio.addEventListener('change', function() {
              const isMemberSelected = this.value === 'member';

              if (isMemberSelected) {
                $.ajax({
                  type: 'GET',
                  url: '/cart.js',
                  dataType: 'json',
                  success: function(res) {
                    // makes sure to update product id here with production membership id
                    const isProductInCart = res.items.some(item => item.product_id === MEMBERSHIP_PRODUCT_IDS[ENV] );

                    const data = {
                      items: [
                        {
                          id: MEMBERSHIP_VARIANT_IDS[ENV],
                          quantity: 1,
                          selling_plan: SELLING_PLAN_IDS[ENV]
                        }
                      ]
                    };
                    
                    if (window.membershipFreeGift) {
                      data.items.push({
                        id: 45516107645066,
                        quantity: 1
                      });
                    }

                    if (!isProductInCart) {
                      $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        dataType: 'json',
                        data: data,
                        success: function (cart) {
                          window.membershipInCart = true
                          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
                          theme.rerenderCartPageBody();
                        },
                        error: function (error) {
                          console.error('Error adding product to cart:', error);
                        }
                      });
                    }
                  },
                  error: function(error) {
                    console.error('Failed to fetch cart contents:', error);
                  }
                });
              } else {
                theme.removeMembershipProduct();
              }


            });
          });
        });

      }
    });
  }

  theme.enableDisableElements = enableDisableElements
  theme.attachToggleEventListeners = attachToggleEventListeners
}


theme.memberStatusActiveAfterLogoutOrLogin = function() {
  const noMembershipOption = sessionStorage.getItem('Membership Option') === "None";
  const noSessionOption = sessionStorage.getItem('Membership Option') === null;

  // Handle logout
  if (window.location.href.indexOf('customer-logout') > -1 && (noMembershipOption || noSessionOption)) {
    localStorage.setItem('toggleState', true);
  }

  // Handle login
  if (window.location.href.indexOf('logged-in=true') > -1 && (noMembershipOption || noSessionOption)) {
    localStorage.setItem('toggleState', true);
  }

}


// ********************* Quantity selector **********************

theme.quantitySelector = function () {

  $('.js-qty__button').on('click keyup', function(e) {
    if ( e.type === 'keyup' && e.keyCode !== 13 ) return;
    e.preventDefault();

    var el = $(this),
        qtySelector = el.siblings('.js-qty__input'),
        qty = parseInt(qtySelector.val().replace(/\D/g, '')),
        maxValueBundle = parseInt(qtySelector.attr('data-max-value'));

    // Make sure we have a valid integer
    if(!(parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      qty = 1;
    }
    // Add or subtract from the current quantity
    if (el.hasClass('js-qty__button--plus')) {
      qty = qty + 1;

      if (qty > 0) {
        el.siblings('.js-qty__button').removeAttr('disabled')
      }
      // only for bundle
      if (maxValueBundle && qty >= maxValueBundle) {
        qty = maxValueBundle;
        el.attr('disabled', 'true');
      } // end for bundles
    } else {
      qty = qty - 1;

      // only for bundle
      if (maxValueBundle && qty <= maxValueBundle) {
        el.siblings('.js-qty__button').removeAttr('disabled')
      }// end for bundle
      if (qty <= 0) {
        qty = 0;
        el.attr('disabled', 'true');
      }
    }
    // Update the input's number
    theme.syncSameProducts()
    qtySelector.val(qty).trigger('change');
  });

  // All quantity input value change on up/down arrows key press
  $('.js-qty__input')
    .on('keyup', function(e) {
      // On arrow up key press (38)
      if ( e.keyCode == 38 ) {
        $(this).siblings( '.js-qty__button--plus' ).trigger( 'click' );
      }
      // On arrow down key press (40)
      if ( e.keyCode == 40 ) {
        $(this).siblings( '.js-qty__button--minus' ).trigger( 'click' );
      }
    });
}

// ********************* Collection sort on click style **************

theme.sortIcon = function (e) {
  $(document).ready(function(){
    $(document).on('click','.CollectionToolbar__Item--sort',function(e){
      const drawerIcon = $('.Icon--select-arrow');
      if($(e.target).attr('aria-expanded') != 'false')
        drawerIcon.css('transform', 'rotate(180deg)');
      else
        drawerIcon.css('transform', 'rotate(0deg)');
    })
  })
}

// ********************** Reorder click ******************************

theme.reorder = function (e) {
  $(document).ready(function(){
    function getProductInfo(productHandle) {
      return $.ajax({
        type: "GET",
          url: "/products/" + productHandle + ".js",
          dataType: "json",
          async: false,
          success: function (data) {
            return data;
          },
      }); //    return jQuery.getJSON('/products/'+productHandle+'.js')
    }

    $(document).on("click", "#Reorder_last_order", function (e) {
      const lastOrderObj = [];
      const promise = [];
      $(e.target).data("lastOrder").forEach(order => {
        promise.push(getProductInfo(order.product.handle).then(data => {
          if(data.variants[0].available)
              lastOrderObj.push({'id': order.product.variants[0].id, 'quantity': order.quantity,'properties':{...order.properties}});
        }))

      });
      $(e.target).css('cursor','wait');
      // need to wait till available check for each item in order is done (each check = fetch info for each product)
      Promise.all(promise).then(()=> {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: { items: lastOrderObj },
          dataType: "json",
          success: function (data) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
            $(e.target).css('cursor','auto');
          },
          error: function (error) {
            if (error.status == 422) {
              alert(error.responseJSON.description);
            }
          }
        });
      })

    });
  })
}


theme.handleMembershipSelection = function () {
  const sidebarCartButton = document.querySelector("[data-action='open-drawer'][data-drawer-id='sidebar-cart']");

  sessionStorage.setItem("Membership Option", "Annual 65 No Trial free shipping");
  addProductToCartOnce([MEMBERSHIP_VARIANT_IDS[ENV]], SELLING_PLAN_IDS[ENV]);

  if (sidebarCartButton) {
      setTimeout(() => {
          sidebarCartButton.click();
      }, 500);
  }
}

theme.klevuPopupVisibility = function (event) {
  document.querySelectorAll('.member_popup.visible').forEach(popup => {
    popup.classList.remove('visible');
  });

  if (!event.target) return;

  const memberPopup = event.target.querySelector('.member_popup');

  if (memberPopup) {
    memberPopup.classList.add('visible');
  }
};

theme.memberPopupLogic = function () {
  const memberPrices = document.querySelectorAll(".Member_Price");
  const joinTodayHeader = document.querySelector(".Join_Today_Header");
  const joinTodayArr = joinTodayHeader ? [joinTodayHeader] : [];

  const isHomepageMobile = document.body.classList.contains("template-index") && window.innerWidth < 1007;
  const homepagePopup = document.querySelector(".homepage-member-popup .member_popup");
  const homepageJoinToday = homepagePopup?.querySelector(".Join_Today");

  const isPDPForPopup = document.body.classList.contains("template-product")
  const priceContainer = document.querySelector('.Product__InfoWrapper');

  let currentVisiblePopup = null; // Track the currently visible popup

  const togglePopupVisibility = (popup, isVisible) => {
    if (isVisible) {
      if (currentVisiblePopup && currentVisiblePopup !== popup) {
        // Close the currently visible popup
        currentVisiblePopup.classList.remove("visible");
        currentVisiblePopup.setAttribute("aria-hidden", "true");
      }

      // Show the current popup
      popup.classList.add("visible");
      popup.setAttribute("aria-hidden", "false");
      currentVisiblePopup = popup; // Update the tracker
    } else {
      // Hide the popup
      popup.classList.remove("visible");
      popup.setAttribute("aria-hidden", "true");
      if (currentVisiblePopup === popup) {
        currentVisiblePopup = null; // Clear the tracker if this popup is closed
      }
    }
  };

  if (isHomepageMobile && homepagePopup) {
    // Homepage-specific logic: Only on homepage mobile
    memberPrices.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.stopPropagation();
        if (!homepagePopup.classList.contains("visible")) {
          togglePopupVisibility(homepagePopup, true);
        }
      });
    });

    document.addEventListener("click", (event) => {
      if (
        !homepagePopup.contains(event.target) &&
        ![...memberPrices].some((el) => el.contains(event.target))
      ) {
        togglePopupVisibility(homepagePopup, false);
      }
    });

    const closeHomepagePopup = homepagePopup.querySelector(".member_close_popup");
    if (closeHomepagePopup) {
      closeHomepagePopup.addEventListener("click", (event) => {
        event.stopPropagation();
        togglePopupVisibility(homepagePopup, false);
      });
    }

    if (homepageJoinToday) {
      homepageJoinToday.addEventListener("click", () => {
        theme.handleMembershipSelection();
      });
    }
  } else {
    // Default logic for other pages
    let joinTodayMemberhsipPage = document.querySelectorAll(".Join_Today")
    if (joinTodayMemberhsipPage) {
      joinTodayMemberhsipPage.forEach(el => joinTodayArr.push(el))
    }
    if (memberPrices.length) {
      memberPrices.forEach((item) => {
        const popup = item.querySelector("#memberPopup");
        const closePopup = popup?.querySelector(".member_close_popup");
        const joinToday = popup?.querySelector(".Join_Today");

        joinTodayArr.push(joinToday);

        if (!popup || !closePopup || !joinToday) return;

        if (isPDPForPopup && item.parentNode.classList.value.includes('ProductPage_Price')) {
          item.addEventListener("mouseover", (event) => {
            event.stopPropagation();
            if (!popup.classList.contains("visible")) {
              togglePopupVisibility(popup, true);
            }
          });
          priceContainer.addEventListener("mouseleave", (event) => {
            event.stopPropagation();
            togglePopupVisibility(popup, false);
          });
        } else {
          item.addEventListener("click", (event) => {
            event.stopPropagation();
            if (!popup.classList.contains("visible")) {
              togglePopupVisibility(popup, true);
            }
          });
        }

        closePopup.addEventListener("click", (event) => {
          event.stopPropagation();
          togglePopupVisibility(popup, false);
        });

        document.addEventListener("click", (event) => {
          if (!popup.contains(event.target) && !item.contains(event.target)) {
            togglePopupVisibility(popup, false);
          }
        });

        joinToday
      });
    }

    // try it now on pdp does not add membership to cart anymore
    // let tryItNow = null;
    // if (isPDPForPopup) { tryItNow = document.querySelector(".Member_Price_TryItNow") }
    // if (tryItNow) { joinTodayArr.push(tryItNow) }

    joinTodayArr.forEach((button) => {
      if (button.dataset.listenerAttached === "true") return;

      button.addEventListener("click", () => {
        theme.handleMembershipSelection();
      });
    
      // Mark it as initialized so we don't rebind later
      button.dataset.listenerAttached = "true";
    });

  }
};



// ********************** Info Popup ******************************

theme.infoPopupLogic = function() {

  $(document).on('click touchend', '.info-icon, .Member_Price_TryItNow', function(evt) {
    evt.preventDefault();

    if ($('.info-popup').hasClass('is-open')) return;

    $('.info-popup').addClass('is-open');
    $('body').css('overflow', 'hidden');
    $(document).on('click touchend', handleOutsideClick);
    $(document).on('keydown', handleEscKey);

    if (sessionStorage.getItem('Membership Option') === "Annual 69 No Trial") {
      document.getElementById('MembershipPopup__price-update').innerHTML = "Join today for $69 and get $60 of instant value."
    }
  });

  $(document).on('click touchend', '[data-close-popup]', function(evt) {
    evt.preventDefault();
    closeInfoPopup();
  });

  function closeInfoPopup() {
    $('.info-popup').removeClass('is-open');
    $('body').css('overflow', '');
    $(document).off('click touchend', handleOutsideClick);
    $(document).off('keydown', handleEscKey);
  }

  function handleOutsideClick(event) {
    const $infoPopup = $('.info-popup');
    const $infoPopupContent = $('.info-popup-content');

    if ($infoPopup.hasClass('is-open') &&
        $infoPopup.is(event.target) &&
        !$infoPopupContent.is(event.target) &&
        !$infoPopupContent.has(event.target).length) {
      closeInfoPopup();
    }
  }

  function handleEscKey(event) {
    if (event.key === 'Escape') {
      closeInfoPopup();
    }
  }
};

// ********************* Product cart **********************

theme.productCard = function () {
  $(document).off().on('click keyup', '.js-qty__adjust',  function(e) {
    if ( e.type === 'keyup' && e.keyCode !== 13 ) return;

    var el = $(this),
      $cardWrapper = el.parents('.ProductCard'),
      $cardImageWrapper = $cardWrapper.find('.ProductCard__ImageWrapper'),
      $cardAnimatedCount = $cardWrapper.find('.ProductCard__AnimatedCount'),
      $qtySelector = el.parent(),
      $qtySelectorInput = el.siblings('.js-qty__num'),
      $qtyAddBtn = $cardWrapper.find('.js-qty__adjust--plus'),
      $maxQuantity = parseInt($qtySelectorInput.attr('max')),
      id = $qtySelectorInput.attr('data-variant-id'),
      qty = parseInt($qtySelectorInput.val().replace(/\D/g, ''));

    // Make sure we have a valid integer
    if(!(parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      qty = 1;
    }

    // Add or subtract from the current quantity
    if (el.hasClass('js-qty__adjust--plus')) {
      qty = qty + 1;
    } else {
      qty = qty - 1;
      if (qty <= 0) {
        qty = 0;
        const productPage = location.href.indexOf('/products') > 0? true : false;
        $cardWrapper.removeClass('option-is-open');
        $qtySelector.attr('aria-hidden', 'true');
      }
    }
    if ($maxQuantity <= qty) {
      $qtyAddBtn.attr('disabled', 'disabled')
      document.getElementById('purchaselimitReached').style.display = "block";
    } else {
      $qtyAddBtn.removeAttr('disabled');
    }

    $qtySelectorInput.val(qty).trigger('change');
    var $errorMessage = $(this).closest('.AddToCart__ErrorMessage')
    var data = {
      [id]: qty
    };

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: {
        updates: data
      },
      success: function () {
        $cardAnimatedCount.html(qty);
        $cardImageWrapper.addClass('ProductCard__Animated');
        theme.syncSameProducts(id, qty);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        if (qty === 0) {
          $cardWrapper.find('.subscribtion__options').attr('aria-hidden','true');
          $cardWrapper.find('.subscribtion__options').hide()
          $qtySelectorInput.val(1).trigger('change');
        }

        // upsellplusapp.init_drawer_offer();

        setTimeout(() => {
          $cardImageWrapper.removeClass('ProductCard__Animated');
        }, 800 )

        theme.rerenderCartPageBody();

      },
      error: function (error) {
        if (error.status == 422) {
          $errorMessage.text(error.responseJSON.description).fadeIn('slow');

          setTimeout( () => {
            $errorMessage.fadeOut('slow').text('');
          }, 6000);
        }
      }
    });
  });

  // disable any interaction with ProductCard elements during scrolling on Android
  function isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  let isScrolling;

  function disableClicksDuringScroll() {
    const productCards = document.querySelectorAll('.ProductCard');
    productCards.forEach(card => {
        card.style.pointerEvents = 'none';
    });
  }

  function enableClicksAfterScroll() {
    const productCards = document.querySelectorAll('.ProductCard');
    productCards.forEach(card => {
        card.style.pointerEvents = 'auto';
    });
  }

  if (isAndroid()) {
    window.addEventListener('scroll', function() {
        disableClicksDuringScroll();

        clearTimeout(isScrolling);

        isScrolling = setTimeout(function() {
            enableClicksAfterScroll();
        }, 250);
    });
  }

  //using touchstart and touchend to fix the bug of accidental click on ATC while scrolling
  var touch_pos;
  $(document).on("touchstart", "[data-product-add-to-cart]", function (e) {
    touch_pos = $(window).scrollTop();
  }).on('click touchend', '[data-product-add-to-cart]', function(evt) {
    evt.preventDefault();
    if (evt.type == "touchend" && Math.abs(touch_pos - $(window).scrollTop()) > 3)
      return;

    var $wrapper = $(this).parents('.ProductCard__AddToCart'),
      $cardWrapper = $(this).parents('.ProductCard'),
      $cardImageWrapper = $cardWrapper.find('.ProductCard__ImageWrapper'),
      $cardAnimatedCount = $cardWrapper.find('.ProductCard__AnimatedCount'),
      $errorMessage = $wrapper.find('.AddToCart__ErrorMessage'),
      productLimit = $wrapper.data('productLimit'),
      id = $wrapper.find('[data-variant-id]').attr('data-variant-id'),
      sku = $wrapper.find('[data-product-sku]').attr('data-product-sku'),
      qty = $wrapper.find('[data-product-add-input]').val(),
      $qtySelector = $wrapper.find('.ProductCard__Quantity'),
      $qtySelectorIncrease = $qtySelector.find('.QuantitySelector__Button--increase'),
      $popup = $('.BundleBuilder__Popup'),
      $isAutoshipCollection = theme.urlContains('collections/auto-ship');

      if ( qty == 0 ) {
        qty = 1;
      }

      let $subSelection = $cardWrapper.find('#Sub__Plans-options');
      let selling_plan = $subSelection.find('input[type="radio"]:checked').data('planId');

    theme.canceledMember()

    if(parseInt(productLimit) <= qty) {
      $qtySelectorIncrease.attr('disabled', 'true');
    }

    if($isAutoshipCollection) {
      data = {
        "id": parseInt(id),
        "quantity": parseInt(qty),
        "selling_plan": selling_plan,
        // 'properties':{'autoship':true}
      }
    } else {
      var data = {
        id: id,
        quantity: qty
      };
    }


    $('.BundleBuilder__PopupClose, .BundleBuilder__PopupCloseIcon').on('click', function () {
      $popup.fadeOut();
      $('html').removeClass('no-scroll');
      data = {};
      return;
    });

    $('.BundleBuilder__PopupSubmit').on('click', function () {
      sessionStorage.setItem('bundlePopupShown','true');
      addCurrentProduct()
      $popup.fadeOut();
      $('html').removeClass('no-scroll');
      data =  {...data,properties:{wineSku:wineVariantIdSku[sku]}}
    });

    if(wineVariantIdSku[sku] && sessionStorage.getItem('bundlePopupShown') === null && $popup.length){
      $popup.fadeIn();
      $('html').addClass('no-scroll');
      return;
    }

    addCurrentProduct().then(()=>{
      const customerLoggedIn = window.customer && window.customer.loggedIn;

      if(typeof $(this).data('subscribtion') !== 'undefined'){
        if($isAutoshipCollection){
          $cardWrapper.find('.subscribtion__options').find('input[value="subscription"]').prop('checked', true);
          $cardWrapper.find('.subscribtion__options').css('display','flex');
          if(customerLoggedIn && !$cardWrapper.parent()[0].hasClass('.kuEachRecProduct')) { $cardWrapper.addClass('option-is-open')}
        } else {
          $cardWrapper.find('.subscribtion__options').find('input[value="onetime"]').prop('checked', true);
          $cardWrapper.find('.subscribtion__options').css('display','flex');
          $cardWrapper.find('.sub__radio-btns').hide();
          if(customerLoggedIn && !$cardWrapper.parent()[0].hasClass('.kuEachRecProduct')) { $cardWrapper.addClass('option-is-open')}
        }
      }
    });


    function addCurrentProduct() {

      if(wineVariantIdSku[sku]) {
        data =  {...data,properties:{wineSku:wineVariantIdSku[sku]}}
      }
       return $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function (data) {

          Shopify.getCart(function(cart){

            //************* Capture add to cart event for Mixpanel */
            var url = location.href;
            if(window.location.href.indexOf('cart') > -1) {
              theme.rerenderCartPageBody();
            }

            if(url.indexOf("_pos") > -1){
              mixpanel.track("Item Added To Cart", {
                "Entry Point": "Search",
                "Page": "Search",
                "Item Name": data.title,
                "Item Cost": data.price,
                "Item ID": data.id,
                "Item Quantity": data.quantity,
                "UTM Source Current": parsedLocallySavedUTMS ? parsedLocallySavedUTMS.source : null,
                "UTM Medium Current" : parsedLocallySavedUTMS ? parsedLocallySavedUTMS.medium : null,
                "UTM Term Current": parsedLocallySavedUTMS ? parsedLocallySavedUTMS.term : null,
                "UTM Campaign Current": parsedLocallySavedUTMS ? parsedLocallySavedUTMS.campaign : null,
                "UTM Content Current": parsedLocallySavedUTMS ? parsedLocallySavedUTMS.content : null,
                "Active Member": activeMember,
                "Website": "DTC"
              });
            }

           if(url.indexOf("collection") > -1){
             mixpanel.track("Item Added To Cart", {
                "Page": "Collection",
                "Entry Point": "Browse",
                "Item Name": data.title,
                "Item Cost": data.price,
                "Item ID": data.id,
                "Item Quantity": data.quantity,
                "UTM Source Current": parsedLocallySavedUTMS ? parsedLocallySavedUTMS.source : null,
                "UTM Medium Current" : parsedLocallySavedUTMS ? parsedLocallySavedUTMS.medium : null,
                "UTM Term Current": parsedLocallySavedUTMS ? parsedLocallySavedUTMS.term : null,
                "UTM Campaign Current": parsedLocallySavedUTMS ? parsedLocallySavedUTMS.campaign : null,
                "UTM Content Current": parsedLocallySavedUTMS ? parsedLocallySavedUTMS.content : null,
                "Active Member": activeMember,
                "Website": "DTC"
              });
           }

            // $qtySelector.attr('aria-hidden', 'false');
            // $cardAnimatedCount.html(qty);
            $cardImageWrapper.addClass('ProductCard__Animated');
            theme.syncSameProducts(id, 1)
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
            document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: data.id,
                quantity: data.quantity
              }
            }))

            setTimeout(() => {
              $cardImageWrapper.removeClass('ProductCard__Animated');
            }, 800 )

          }.bind(this));

        },
        error: function (error) {
          if (error.status == 422) {
            $errorMessage.text(error.responseJSON.description).fadeIn('slow');

            setTimeout( () => {
              $errorMessage.fadeOut('slow').text('');
            }, 6000);
          }
        }
      });
    }

  });

  theme.updateProductCardUI = function (variantId, card, updateDefaultVariant, variantLabels) {
    const variantButton = document.querySelector(`.ProductCard__VariantButton[data-variant-button-id="${variantId}"]`);

    if (!variantId) return;

    const handle = card?.dataset.productHandle;
    if (!card || !handle) return;

    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        const variant = product.variants.find(v => v.id == variantId);

        if (!variant) return;

        // Update ANY product links in the card (including collection paths)
        const els = Array.from(
          card.querySelectorAll('a[href*="/products/"], [data-href*="/products/"]')
        );

        els.forEach(el => {
          const raw = el.getAttribute('href') || el.getAttribute('data-href');
          if (!raw) return;

          const url = new URL(raw, window.location.origin);

          // Only touch links that point to this product
          if (!url.pathname.includes(`/products/${handle}`)) return;

          // Set/replace the variant param, keep path + hash intact
          url.searchParams.set('variant', variant.id);
          const updated = url.pathname + url.search + url.hash;

          if (el.tagName === 'A') el.setAttribute('href', updated);
          if (el.hasAttribute('data-href')) el.setAttribute('data-href', updated);
        });

        const productButton = card.querySelector('[data-product-button]');
        // update Shop Now button link
        if (productButton) {
          const isAtc = productButton.dataset.isAtc;
          if (isAtc === "false") {
            const baseUrl = productButton.dataset.baseUrl;
            const newUrl = `${baseUrl}?variant=${variant.id}`;
            productButton.setAttribute('onclick', `window.location.href='${newUrl}'`);
          }
        }

        // ----- LABELS BEGIN -----
        if (!card || !variant) return;

        const container = card.querySelector('.ProductCard__LabelContainer');
        if (!container) return;

        // Inner wrapper that stores data-* attributes
        const inner = container.querySelector('[data-variant-id]') || container;

        // Existing elements (if Liquid rendered them)
        let saleLabel      = inner.querySelector('.Sale_Label');
        let discountLabel  = inner.querySelector('.Discount_Label');
        let variantLabelEl = inner.querySelector('.Variant_Label');

        // -------- Parse product tags from data attribute --------
        let tags = [];
        try {
          const raw = inner.getAttribute('data-tags');
          tags = raw ? JSON.parse(raw) : [];
        } catch (e) {
          tags = [];
        }
        if (!Array.isArray(tags)) {
          tags = String(tags || '').split(',').map(t => t.trim()).filter(Boolean);
        }

        const hideSale = tags.includes('HideSaleLabel');

        const customLabelTag = tags.find(t => t.indexOf('__label:') !== -1);
        const customSaleText = customLabelTag ? customLabelTag.split('__label:').pop().trim() : '';

        const savingsTag  = tags.find(t => t.indexOf('__labelsavings:') !== -1);
        const savingsText = savingsTag ? savingsTag.split('__labelsavings:').pop().trim() : '';

        // -------- Variant label map (string or object) --------
        let vMap = {};
        try {
          vMap = (typeof variantLabels === 'string') ? JSON.parse(variantLabels || '{}') : (variantLabels || {});
        } catch (_) {
          vMap = {};
        }
        const vid = String(variant.id);
        const variantTextRaw = vMap[vid] ?? vMap[Number(vid)];
        const variantText = variantTextRaw ? String(variantTextRaw).trim() : '';
        const hasVariantText = !!variantText;

        // -------- Sale condition --------
        const onSale = Number(variant.compare_at_price) > Number(variant.price);

        // -------- VARIANT vs DISCOUNT --------
        if (hasVariantText) {
          // Ensure Variant_Label exists
          if (!variantLabelEl) {
            variantLabelEl = document.createElement('span');
            variantLabelEl.className = 'ProductCard__Label Heading Variant_Label';
            inner.appendChild(variantLabelEl);
          }
          variantLabelEl.textContent = variantText;
          variantLabelEl.style.display = 'inline-flex';

          // Hide discount label when variant label is active
          if (discountLabel) {
            discountLabel.textContent = savingsText || discountLabel.textContent || '';
            discountLabel.style.display = 'none';
          }
        } else {
          // Hide variant label
          if (variantLabelEl) {
            variantLabelEl.textContent = '';
            variantLabelEl.style.display = 'none';
          }
          // Show discount label if we have a savings tag
          if (savingsText) {
            if (!discountLabel) {
              discountLabel = document.createElement('span');
              discountLabel.className = 'ProductCard__Label Heading Discount_Label';
              inner.appendChild(discountLabel);
            }
            discountLabel.textContent = savingsText;
            discountLabel.style.display = 'inline-flex';
          } else if (discountLabel) {
            discountLabel.textContent = '';
            discountLabel.style.display = 'none';
          }
        }

        // -------- SALE LABEL (On Sale / custom fallback) --------
        if (hideSale) {
          if (saleLabel) saleLabel.style.display = 'none';
        } else {
          if (onSale) {
            // Show "On Sale"
            if (!saleLabel) {
              saleLabel = document.createElement('span');
              saleLabel.className = 'ProductCard__Label Heading Sale_Label';
              saleLabel.textContent =
                (window.theme && window.theme.strings && window.theme.strings.productOnSale) || 'On Sale';
              inner.appendChild(saleLabel);
            } else {
              // If a custom label was pre-rendered, overwrite to "On Sale" while on sale
              const defaultText =
                (window.theme && window.theme.strings && window.theme.strings.productOnSale) || 'On Sale';
              saleLabel.textContent = defaultText;
            }
            saleLabel.style.display = 'inline-flex';
          } else {
            // Not on sale: show custom __label: text only if present AND no variant label
            if (customSaleText && !hasVariantText) {
              if (!saleLabel) {
                saleLabel = document.createElement('span');
                saleLabel.className = 'ProductCard__Label Heading Sale_Label';
                inner.appendChild(saleLabel);
              }
              saleLabel.textContent = customSaleText;
              saleLabel.style.display = 'inline-flex';
            } else if (saleLabel) {
              saleLabel.style.display = 'none';
            }
          }
        }
        // ----- LABELS END -----

        // 1. Update image if available
        const imageWrapper = card.querySelector('.ProductCard__ImageWrapper');
        const mainImage = imageWrapper?.querySelector('.ProductCard__Image');
        const imageEl = imageWrapper?.querySelector('img');
        const hoverImage = imageWrapper.querySelector('.ProductCard__ImageHover');

        if (imageEl && variant.featured_image && variant.featured_image.src) {
          const imageUrl = variant.featured_image.src;
          const baseUrl = imageUrl.split('?')[0]; // clean query params
          const imageId = baseUrl.split('/').pop().split('.')[0]; // extract image identifier (e.g. Shampoo-copy_543e...)

          // Shopify CDN pattern: [basename]_[width]x.jpg
          const srcsetSizes = [360, 540, 720, 900, 1080, 1296, 1512, 1728, 1920, 2560];
          const srcset = srcsetSizes.map(size =>
            `${baseUrl.replace(/(\.\w+)$/, `_${size}x$1`)} ${size}w`
          ).join(', ');
        
          imageEl.src = imageUrl;
          imageEl.srcset = srcset;
          imageEl.dataset.src = imageUrl;
          imageEl.dataset.srcset = srcset;
          imageEl.alt = variant.title || product.title;

          mainImage.style.visibility = "visible";
          mainImage.style.opacity =  100;

          if (hoverImage) {
            hoverImage.style.visibility = "hidden";
            hoverImage.style.opacity =  0;
          }
        }
        
        // Update pricing
        const priceContainer          = card.querySelector('.card-product-price .Price');
        let   comparePriceContainer   = card.querySelector('.card-product-price .Price--compareAt');
        const memberText              = card.querySelector('.card-product-price .Member_Price');
        
        const activeMember = !!window.activeMember;
        const legacyMember = !!window.legacyMember;
        
        // dataset values are in CENTS (strings). Coerce to numbers.
        const legacyPriceCents = Number(variantButton?.dataset.legacyPrice) || 0;  // discounted member price (legacy)
        const newPriceCents    = Number(variantButton?.dataset.newPrice)    || 0;  // discounted member price (new)
        const newDiscountPct   = Number(variantButton?.dataset.newDiscount) || 0;  // e.g. "20" for 20%
        
        const basePriceCents   = Number(variant.price) || 0;
        const compareAtCents   = Number(variant.compare_at_price) || 0;
        
        // Format helper
        const fmt = (cents) => {
          try { return theme.Currency.formatMoney(cents); }
          catch { return (Number(cents || 0) / 100).toFixed(2); }
        };
        
        // Compute displayed (current) price
        let finalPriceCents = basePriceCents;
        if (legacyMember && activeMember && legacyPriceCents > 0) {
          finalPriceCents = legacyPriceCents;
        } else if (activeMember && newPriceCents > 0) {
          finalPriceCents = newPriceCents;
        }
        
        // 1) Update current price
        if (priceContainer) {
          priceContainer.textContent = fmt(finalPriceCents);
        }
        
        // 2) Show crossed-out compare-at when truly on sale (Shopify rule: compare_at > base price)
        const isOnSale = compareAtCents > basePriceCents;
        
        // Ensure compare node exists (Liquid may not render it initially)
        if (!comparePriceContainer) {
          comparePriceContainer = document.createElement('span');
          comparePriceContainer.className = 'Price--compareAt compare-at-price';
          // append right after the current price
          if (priceContainer && priceContainer.parentNode) {
            priceContainer.parentNode.appendChild(comparePriceContainer);
          } else {
            card.querySelector('.card-product-price')?.appendChild(comparePriceContainer);
          }
        }
        
        if (isOnSale) {
          comparePriceContainer.textContent = fmt(compareAtCents);
          comparePriceContainer.style.display = ''; // let CSS apply strike-through
          // If your theme doesn't strike through automatically, uncomment:
          // comparePriceContainer.style.textDecoration = 'line-through';
        } else {
          comparePriceContainer.textContent = '';
          comparePriceContainer.style.display = 'none';
        }
      });
  };
  
  function reorderVariantButtons(card, matchedVariantId) {
    const container = card.querySelector('.ProductCard__Variants');
    if (!container) return;
  
    const buttons = Array.from(container.querySelectorAll('.ProductCard__VariantButton'));
    if (!buttons.length) return;
  
    // Split buttons into matched vs others
    const matched = [];
    const others = [];
  
    buttons.forEach(btn => {
      if (String(btn.dataset.variantButtonId) === String(matchedVariantId)) {
        matched.push(btn);
      } else {
        others.push(btn);
      }
    });
  
    // Re-append them so matched ones show first
    [...matched, ...others].forEach(btn => container.appendChild(btn));
  }

  // NEW: single source of truth for variant selection on cards
  function attachCardVariantHandlers(card) {
    const buttons        = card.querySelectorAll('.ProductCard__VariantButton');
    if (!buttons.length) return;

    const matchId        = card.dataset.variantCollectionMatchId || '';
    const variantLabels  = card.dataset.variantLabels ? JSON.parse(card.dataset.variantLabels) : '';

    // legacy targets your old code updated:
    const addInputEl     = card.querySelector('[data-product-add-input]') || card.querySelector('[data-variant-id]');
    const addToCartEl    = card.querySelector('[data-product-add-to-cart]');

    // helper to sync the chosen variant ID to all targets
    const setVariantAttrs = (vid) => {
      if (addInputEl)  addInputEl.setAttribute('data-variant-id', vid);
      if (addToCartEl) addToCartEl.setAttribute('data-variant-id', vid);
      const idInput = card.querySelector('input[name="id"]'); // if present
      if (idInput) idInput.value = vid;
    };

    // default select (prefer matchId)
    buttons.forEach(b => b.classList.remove('is-selected'));
    const first = [...buttons].find(b => b.dataset.variantButtonId === matchId) || buttons[0];
    first.classList.add('is-selected');
    setVariantAttrs(first.dataset.variantButtonId);

    // If we used the match id, reorder so it appears first (your old behavior)
    if (matchId) reorderVariantButtons(card, matchId);

    // initial UI update
    theme.updateProductCardUI(first.dataset.variantButtonId, card, matchId, variantLabels);

    // click handler (no jQuery; prevents double-tap weirdness)
    buttons.forEach(button => {
      button.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (button.disabled) return;

        buttons.forEach(b => b.classList.remove('is-selected'));
        button.classList.add('is-selected');

        const vid = button.dataset.variantButtonId;
        setVariantAttrs(vid);
        theme.updateProductCardUI(vid, card, matchId, variantLabels);
      });
    });
  }

  // INIT — replaces old forEach loop AND the jQuery delegate
  document.querySelectorAll('.ProductCard').forEach(attachCardVariantHandlers);

  // Optional: if a dragscroll wrapper sometimes steals taps, keep taps from bubbling up
  document.addEventListener('pointerdown', (e) => {
    if (e.target.closest('.ProductCard__VariantButton')) e.stopPropagation();
  }, { capture: true });
  document.addEventListener('touchstart', (e) => {
    if (e.target.closest('.ProductCard__VariantButton')) e.stopPropagation();
  }, { capture: true, passive: true });

}

// ********************* Sync PLP Cards *****************

theme.syncSameProducts = function(variantId, quantity) {
  const isAutoship = theme.urlContains('collections/auto-ship');
  const customerLoggedIn = window.customer && window.customer.loggedIn;

  let $products = $('.ProductCard [data-variant-id="' + variantId + '"]');

  // If no matching product found for member variant ID, try non-member variant ID
  if ($products.length === 0) {
    $products = $('.ProductCard [data-nonmember-variant-id="' + variantId + '"]');
  }

  // Check if the subscription option is checked in the main product
  const $mainProduct = $products.first().closest('.ProductCard');
  const mainSubChecked = $mainProduct.find('.subscribtion__options input[value="subscription"]').is(':checked');

  $products.each(function () {
    const $wrapper = $(this).closest('.ProductCard');
    const $qtyInput = $wrapper.find('.js-qty__num');
    const $animatedCount = $wrapper.find('.ProductCard__AnimatedCount');
    const $imageWrapper = $wrapper.find('.ProductCard__ImageWrapper');
    const $qtySelector = $wrapper.find('.ProductCard__Quantity');
    const $subOptions = $wrapper.find('.subscribtion__options');
    const $radioBtns = $wrapper.find('.sub__radio-btns');

    if (quantity == 0) {
      $subOptions.attr('aria-hidden', 'true').hide();
      $wrapper.removeClass('option-is-open');
      $wrapper.find('.subscribtion__options').hide();
      // $qtySelector.attr('aria-hidden', 'true');
    } else {
      $subOptions.attr('aria-hidden', 'false').css('display', 'flex');
      // $qtySelector.attr('aria-hidden', 'false');

      if (isAutoship) {
        $subOptions.find('input[value="subscription"]').prop('checked', true);
        if (customerLoggedIn && $subOptions.length > 0 && !$wrapper.parent().hasClass('kuEachRecProduct')) {$wrapper.addClass('option-is-open');}
      } else {
        if (mainSubChecked) {
          $subOptions.find('input[value="subscription"]').prop('checked', true);
          $radioBtns.show();
        } else {
          $subOptions.find('input[value="onetime"]').prop('checked', true);
          $radioBtns.hide();
        }
        if (customerLoggedIn && $subOptions.length > 0 && !$wrapper.parent().hasClass('kuEachRecProduct')) {$wrapper.addClass('option-is-open');}
      }
    }

    $qtyInput.val(quantity).trigger('change');
    $animatedCount.html(quantity);
    $imageWrapper.addClass('ProductCard__Animated');

    setTimeout(() => $imageWrapper.removeClass('ProductCard__Animated'), 800);
  });
}

// ********************* Autofill Notify me popup *****************
theme.backinstockPopup = function () {
  //Global variable that can be use for both popup and also submit function
  let productData, productId, variantId;
  const backinstockPopup = $('.backinstock__popup');

  $(document).on('click','.BIS_custom',function(event) {
    event.preventDefault();

    productData = $(event.target).data('productData');

    if (typeof productData === "string") {
      productId = $(event.target).data('productId');
      variantId = $(event.target).data('variantId');
    } else {
      productId = productData.id
      variantId = productData.variants[0].id
    }

    let productTitle = $('.backinstock__popupProductTitle');

    //hide success message if it's shown from previous popup
    $('.backinstock__popupSuccess').css('display') == 'block' && $('.backinstock__popupSuccess').hide();
    productTitle.text(productData.title);

    //Auto fill input if customer
    if($(event.target).data('customerEmail')) {
      const customerEmail = $(event.target).data('customerEmail');
      $('.backinstock__popupEmailInput').val(customerEmail);
    }

    //show popup after getting all info for display
    backinstockPopup.css('display') == 'none' && backinstockPopup.show();

    //close popup on X click
    $(document).on('click','.backinstock__popupCloseIcon',function(e) {
      backinstockPopup.css('display') == 'block' && backinstockPopup.hide();
      $('.backinstock__popupEmailInput').val("");
      $('.backinstock__popupSuccess').hide();
    })
  })

  //Create notification after submit is clicked
  $(document).on('click','#backinstock__popupSubmit',function(e) {
    e.preventDefault();
    e.stopPropagation();

    const backinstockEmail = $('.backinstock__popupEmailInput').val();

    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": backinstockEmail,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    }

    var requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-06-15"
        },
        body: JSON.stringify(payload),
    };

    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=NrdGm5",requestOptions)
    .then(result => {
      if (result.ok === true) {
        backinstockPopup.css('display') == 'block' && $('.backinstock__popupSuccess').show();
      } else {
        result.json().then(errorData => {
          $('.backinstock__popupSuccess').text(errorData.errors[0].detail)
          $('.backinstock__popupSuccess').show();
        })
      }
    })
    .catch(error => {
       //Display error details like 'Email already submit for this product'
       $('.backinstock__popupSuccess').text("Server error. Please contact customer service.");
       $('.backinstock__popupSuccess').show();
    });
  })
}
//************************* Subscription popup*********************

theme.subOptChange = function() {

  $('.ProductCard .subscribtion__options').each(function () {
    const subRadio = $(this).find('.Sub__opt-radio');
    const subsOptions = $(this).find('.sub__radio-btns');
    const AddToCartWrapper = $(this).closest('.ProductCard').find('.ProductCard__AddToCart');
    const variant_id = AddToCartWrapper.find('[data-variant-id]').attr('data-variant-id');
    const $subSelection = $(this).find('#Sub__Plans-options');
    const selectedOptionValue = Shopify.cartItems[variant_id]?.selling_plan_allocation?.selling_plan.id || $subSelection.find('option').first().val();
    subRadio.each((_, element) => { if ($(element).is(':checked') && $(element).val() === 'onetime') subsOptions.hide(); });

    syncSubscriptionOptions(variant_id, selectedOptionValue);
  });

  // Synchronize subscription options across all identical products
  $(document).on('click', '.subscribtion__options .subscription-option', function() {
    const AddToCartWrapper = $(this).closest('.ProductCard').find('.ProductCard__AddToCart');
    const variant_id = AddToCartWrapper.find('[data-variant-id]').attr('data-variant-id');

    syncSubscriptionOptions(variant_id, $(this).data('planId'));
  });

  // Function to synchronize subscription options across all identical products
  function syncSubscriptionOptions(variant_id, selectedOptionValue) {
    $('.ProductCard').each(function() {
      const otherVariantId = $(this).find('.ProductCard__AddToCart').find('[data-variant-id]').attr('data-variant-id');
      if (variant_id === otherVariantId) {
        const otherSubSelection = $(this).find('#Sub__Plans-options');
        const $correctSelectedOption = otherSubSelection.find(`[data-plan-id="${selectedOptionValue}"]`);
        const matchingInput = $(this).find(`.subscription-option[data-plan-id="${selectedOptionValue}"]`);

        if (matchingInput.length > 0) {
          otherSubSelection.val($correctSelectedOption.val()).change();
          matchingInput.prop('checked', true);
        }
      }
    });
  }

  function syncSubOptRadio(variant_id, selectedValue) {
    $('.ProductCard').each(function() {
      const otherVariantId = $(this).find('.ProductCard__AddToCart').find('[data-variant-id]').attr('data-variant-id');
      if (variant_id === otherVariantId) {
        const matchingRadio = $(this).find(`.Sub__opt-radio[value="${selectedValue}"]`);
        const subsOptions = $(this).find('.sub__radio-btns');
        const $subRadio = $(this).find('.delivery-options .subscription-option')[0];

        if (matchingRadio.length > 0) {
          matchingRadio.prop('checked', true);
          selectedValue === 'subscription' ? (subsOptions.slideDown(), $($subRadio).prop('checked', true)) : subsOptions.slideUp();
        }
      }
    });
  }

  $(document).on('click', '.Sub__opt-radio', function() {
    const isProductPage = location.href.indexOf('/products') > 0;
    const $parent = $(this).parents('.subscribtion__options');
    const inputValue = $(this).val();
    const subsOptions = $parent.find('.sub__radio-btns');
    const isPDP = isProductPage && $parent.attr('id') === "subscribtion__options_pdp";
    const $AddToCartWrapper = isPDP ? $('form[action*="/cart/add"]') : $(this).parents('.ProductCard__AddToCart');
    const variant_id = isPDP ? $AddToCartWrapper.find('[data-product-item]').data('productItem') : $AddToCartWrapper.find('[data-variant-id]').attr('data-variant-id');
    const qty = isPDP ? $('.ProductForm__BuyButtons .QuantitySelector__CurrentQuantity').val() : $AddToCartWrapper.find('[data-product-add-input]').val();

    if (inputValue === 'subscription') {
        const $subSelection = $(this).siblings('#Sub__Plans-options');
        const $subRadio = $parent.find('.delivery-options .subscription-option')[0];
        const selling_plan = $subSelection.find('option[selected]').data('planId');
        const item_index = $subSelection.find('option[selected]').data('itemIndex');
        $subSelection.prop('selectedIndex', 0);
        $($subRadio).prop('checked', true);
        subsOptions.slideDown();
        addItemToCart(variant_id, qty, selling_plan, null, 'sub', item_index);
    } else {
        subsOptions.slideUp();
        addItemToCart(variant_id, qty, null, null, 'one-time');
    }

    syncSubOptRadio(variant_id, inputValue);
  });


  $(document).on('click change','#Sub__Plans-options, .rc-selling-plans-dropdown__select',function(e) {
    //Auto select auto-ship radio button if click on options dropdown
    if(e.type == 'click') {
      $(e.target).siblings('.Sub__opt-radio').prop("checked", true);
    }
    const productPage = location.href.indexOf('/products') > 0? true : false;
    const overlay = $(this).parents('.subscribtion__options').find('.subscribtion__loading-overlay');

    if(productPage && $(this).parents('.subscribtion__options').attr('id') === "subscribtion__options_pdp"){
      const formElement = $('form[action*="/cart/add"]');
      variant_id = formElement.find('[data-product-item]').data('productItem');
      qty = $('.ProductForm__BuyButtons .QuantitySelector__CurrentQuantity').val()
    } else {
      const AddToCartWrapper = $(this).parents('.ProductCard__AddToCart');
      qty = AddToCartWrapper.find('[data-product-add-input]').val();
      variant_id = AddToCartWrapper.find('[data-variant-id]').attr('data-variant-id');
    }
      const currentOption = $(e.target).find("option:selected");
      const item_index = $(e.target).find("option:selected").data('itemIndex');

      // console.log("CurrentOption:: ",currentOption);
      addItemToCart(variant_id, qty, currentOption.data('planId'),overlay,'sub',item_index);
  })

}

async function addItemToCart(variant_id, qty, selling_plan, overlay, action, index) {
  if (overlay) overlay.show();

  let data = {
    "line": index,
    "id": parseInt(variant_id),
    "quantity": parseInt(qty),
    "selling_plan": selling_plan
  };

  try {
    const cartResponse = await jQuery.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json'
    });

    let itemFound = cartResponse.items.some((item, i) => {
      if (item.variant_id == data.id) {
        data['line'] = i + 1;
        return true;
      }
      return false;
    });

    if (!itemFound) {
      if (overlay) overlay.hide();
      return;
    }

    await jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data,
      dataType: 'json'
    });

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));

  } catch (error) {
    console.error("Error: ", error.status);
  } finally {
    if (overlay) overlay.hide();
  }
}


//************************* Preselect Subscription PDP************

theme.preselectSub = function () {
  const productPage = location.href.indexOf('/products') > 0? true : false;
  if(productPage){
    const sellingPlanData = $('.ProductForm__BuyButtons').data('sellingPlan');
    const itemInCart = $('.ProductForm__BuyButtons').data('itemInCart')
    const variant_id = $('.ProductForm__BuyButtons').data('productItem');
    let CartItemSellingPlanId;

    //show option by default
    const SubOptions = $('.Product__InfoWrapper .subscribtion__options')
    if(SubOptions.length > 0){
      SubOptions.attr('id','subscribtion__options_pdp')
      SubOptions.find('#Sub__Plans-options').css('background-color','transparent')
    }

    //current product has subscription and it in cart
    // if(sellingPlanData && sellingPlanData.length > 0 && itemInCart){
    //   const sellingPlanDropdown = $('.rc-selling-plans-dropdown__select');
    //   $.ajax({
    //     type: 'GET',
    //     url: '/cart.js',
    //     dataType: 'json',
    //     success: function (data) {
    //       data.items.forEach(item => {
    //         if(item.variant_id == variant_id)
    //           CartItemSellingPlanId = item.selling_plan_allocation? item.selling_plan_allocation.selling_plan.id : null;

    //         $('#rc-radio2').click();

    //         waitForElm('.rc-selling-plans').then((elm) => {
    //           $(`.rc-selling-plans-dropdown__select option[value='${CartItemSellingPlanId}']`).attr('selected','selected');
    //           $(`.rc-selling-plans-dropdown__select`).trigger('change');
    //         });
    //       })
    //     },
    //     error: function (error) {
    //       console.log("Error status: ",error.status);
    //     }
    //   })
    // }
  }
}


//************************* Hide Subscription select for Unsubscribed & Not ActiveUsers &  ************//

theme.hideselectSub = function () {

  const customerLoggedIn = window.customer && window.customer.loggedIn;
  const priceContainer = document.querySelector('.Product__Info .price-container');

  const ProductInfo = document.querySelector('.Product__Info')
  const legacyDiscount = ProductInfo ? ProductInfo.dataset.legacy : null ;
  const newDiscount =  ProductInfo ? ProductInfo.dataset.new: null;
  const ATC = ProductInfo ? ProductInfo.querySelector('.ProductForm__AddToCart') : null;

  const priveDiscount = 5;
  const parentProductCard = $('.subscribtion__options[aria-hidden=false]').closest('.ProductCard');

  if (parentProductCard.length > 0 && customerLoggedIn && !parentProductCard.parent().hasClass('kuEachRecProduct')) {
    parentProductCard.addClass('option-is-open');
  }

  // if (!activeMember) {
  //   document.querySelectorAll('.subscribtion__options').forEach(option => {
  //     option.remove();
  //   });
  // }

  theme.waitForElm('#one .prive_label_title').then(target => {
    if (target) {
      const grandParent = target.parentNode;
      const productWrapper = document.querySelector('.Product__Info')

      const parentContainer = document.createElement('div');
      parentContainer.classList.add('parent-container');

      const wrapper = document.createElement('div');
      wrapper.classList.add('one-time__container');

      const copyText = document.createElement('div');
      copyText.classList.add('one-time__copy-text');

      const copySpan = document.createElement('span');
      // copySpan.textContent = "This needs new copy";
      copyText.appendChild(copySpan);

      const nonMemberPriceInput = productWrapper.querySelector('input.non-member-price');

      if (nonMemberPriceInput) {
        const nonMemberPrice = nonMemberPriceInput.value;
        const priceSpan = document.createElement('span');
        priceSpan.classList.add('non-member-price');
        priceSpan.textContent = `Non-member price: ` + `${nonMemberPrice}`;

        if (sessionStorage.getItem('Membership Option') == null){
          copyText.appendChild(priceSpan)
        }
      }

      grandParent.insertBefore(parentContainer, target);
      parentContainer.appendChild(wrapper);
      wrapper.appendChild(target);

      const priceWrapper = document.createElement('div');
      priceWrapper.classList.add('one-time-price__container');

      wrapper.appendChild(priceWrapper);

      document.querySelectorAll('[id^="oneprice"], [id^="newoneprice"]').forEach(element => {
        priceWrapper.appendChild(element);
      });

      parentContainer.appendChild(copyText);
    }
  });

  theme.waitForElm('#sub .prive_label_title').then(target => {

    if (target) {
      const grandParent = target.parentNode;

      const mainContainer = grandParent.closest('.prive_type_box');
      const parentContainer = document.createElement('div');
      parentContainer.classList.add('parent-container');

      const deliverLabel = document.querySelector('.prive_label_delivery');
      deliverLabel.remove()

      const deliveryEveryBox = document.querySelector('.prive_delivery_every_box');

      const wrapper = document.createElement('div');
      wrapper.classList.add('sub-text-wrapper');

      const copyText = document.createElement('div');
      copyText.classList.add('sub-text__copy-text');

      const copySpan = document.createElement('span');
      // copySpan.textContent = "This needs new copy";
      copyText.appendChild(copySpan);

      const savedPriceInput = document.querySelector('input.saved-price');

      if (savedPriceInput) {
        const savedPrice = savedPriceInput.value;

        const priceSpan = document.createElement('span');
        priceSpan.classList.add('non-member-price');
        priceSpan.textContent = `Save ` + `${savedPrice}`;

        copyText.appendChild(priceSpan);
      }

      grandParent.insertBefore(parentContainer, target);
      parentContainer.appendChild(wrapper);
      wrapper.appendChild(target);

      const priceWrapper = document.createElement('div');
      priceWrapper.classList.add('price-wrapper');

      wrapper.appendChild(priceWrapper);
      document.querySelectorAll('[id^="subprice"], [id^="newsubprice"], [id="discount-disclaimer"]').forEach(element => {
        priceWrapper.appendChild(element);
      });
      parentContainer.appendChild(copyText);

      let deliveryOptions = mainContainer.querySelector('.delivery-options');
      if (!deliveryOptions) {
        deliveryOptions = document.createElement('div');
        deliveryOptions.classList.add('delivery-options');
        deliveryEveryBox.appendChild(deliveryOptions);
        theme.waitForElm('.Product .delivery-options').then(deliveryOptions => {
          theme.waitForElm('.Product .prive_select').then(selectElement => {

            const options = selectElement.options;
            let handleSellingPlanChange = selectElement.getAttribute('onchange');

            const regex = /handleSellingPlanChange\(event,(\d+)\)/;
            const match = handleSellingPlanChange.match(regex);
            let sellingPlanNumber = match ? match[1] : null;

            if (options && options.length > 0) {
              for (let i = 0; i < options.length; i++) {
                const option = options[i];
                const label = document.createElement('label');
                const input = document.createElement('input');
                input.type = 'radio';
                input.name = 'subscription-option';
                input.value = option.value;
                input.setAttribute('data-item-index', i);

                if (i === 0) {
                  input.checked = true;
                  selectElement.value = option.value;
                }

                input.onchange = function (event) {
                  window.PRIVE_WIDGET.PriveWidget.handleSellingPlanChange(event, sellingPlanNumber);
                  selectElement.value = option.value;
                  const changeEvent = new Event('change', { bubbles: true, cancelable: true });
                  selectElement.dispatchEvent(changeEvent);
                };

                label.appendChild(input);
                const span = document.createElement('span');
                span.textContent = option.text;
                label.appendChild(span);
                deliveryOptions.appendChild(label);
              }

              const changeEvent = new Event('change', { bubbles: true, cancelable: true });
              selectElement.dispatchEvent(changeEvent);
            } else {
              console.error('No options found in the select element.');
            }

          //update the cart items onclick custom radio buttons
          document.querySelectorAll('.prive-widget [name="subscription-option"]').forEach(item => {
              item.addEventListener('click', event => {
                  if (activeMember) { theme.applyMemberDiscounts() }
                  const selling_plan = parseInt(event.target.value, 10);
                  const formElement = $('form[action*="/cart/add"]');
                  let variant_id = formElement.find('[data-product-item]').data('productItem');
                  let qty = $('.ProductForm__BuyButtons .QuantitySelector__CurrentQuantity').val();
                  addItemToCart(variant_id, qty, selling_plan, null, 'sub');
              });
          });

          // Adds event listeners to update the cart with the selected variant, quantity, and subscription options upon clicking
          document.querySelectorAll('.prive-widget .prive_label').forEach((label) => {
            const formElement = $('form[action*="/cart/add"]');
            const qtySelector = $('.ProductForm__BuyButtons .QuantitySelector__CurrentQuantity');
            const selectElement = document.querySelector('.prive_select');

            function updateCart(variant_id, qty, selling_plan, type, index) {
                addItemToCart(variant_id, qty, selling_plan, null, type, index);
            }

            function handleLabelClick(event) {
              const parentElement = event.target.closest('.prive_type_box');
              if (!parentElement) return;
              if (activeMember) { theme.applyMemberDiscounts() }

              let variant_id = formElement.find('[data-product-item]').data('productItem');
              let qty = qtySelector.val();
              let selectedOptionValue = selectElement.value;
              let matchingInput = parentElement.querySelector(`[name="subscription-option"][value="${selectedOptionValue}"]`);

              if (matchingInput && !matchingInput.checked) {
                  matchingInput.checked = true;
                  if (selectElement.value !== selectedOptionValue) {
                      selectElement.value = selectedOptionValue;
                      selectElement.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
                  }
              }

              const cartType = parentElement.id === 'sub' ? 'sub' : 'one-time';
              updateCart(variant_id, qty, cartType === 'sub' ? parseInt(selectElement.value, 10) : null, cartType);
          }

          function initializeLabel(label) {
              const parentElement = label.closest('.prive_type_box');
              if (!parentElement) return;

              let variant_id = formElement.find('[data-product-item]').data('productItem');
              let qty = qtySelector.val();
              const cartItem = Shopify.cartItems[variant_id]?.selling_plan_allocation?.selling_plan;
              let selectedOptionValue = cartItem?.id || selectElement.options[0].value;
              const subInput = parentElement.querySelector('.prive_input_radio[value="sub"]');
              let matchingInput = parentElement.querySelector(`[name="subscription-option"][value="${selectedOptionValue}"]`);

              if (cartItem && subInput && !subInput.checked) {
                  subInput.checked = true;
                  subInput.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
              }

              if (matchingInput && !matchingInput.checked) {
                  matchingInput.checked = true;
              }

              if (selectElement.value !== selectedOptionValue) {
                  selectElement.value = selectedOptionValue;
                  selectElement.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
              }

              updateCart(variant_id, qty, cartItem ? parseInt(selectElement.value, 10) : null, cartItem ? 'sub' : 'one-time');

              label.addEventListener('click', handleLabelClick);
          }

          initializeLabel(label);

            });
          });
        });
        const deliveryParent = document.querySelector('.prive_delivery_every_box')
        const frequency = document.createElement('span');
        frequency.textContent = "Frequency"
        deliveryParent.insertBefore(frequency, deliveryOptions)
      }
    }
  });

  document.addEventListener('variant:changed', () => {
    clearTimeout(window._variantChangeTimeout);
    window._variantChangeTimeout = setTimeout(() => {
      document.querySelectorAll('.parent-container, .delivery-options').forEach(el => el.remove());
  
      // Wait another frame or two to let Prive update prices
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (typeof theme.hideselectSub === 'function') {
            theme.hideselectSub();          
          }
        });
      });
    }, 450);
  });

  theme.waitForElm('.prive-widget').then(priveWidget => {

    if (priveWidget) {

      theme.applyMemberDiscounts = function() {
        const productID = document.querySelector('.prive-widget').dataset.priveProductId;
        const priceText = document.getElementById('ProductMeta__Price--Member')?.textContent?.trim();
        let price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        const priveItems = priveWidget.querySelectorAll('.prive_type_box')

          priveItems.forEach(item => {
            const item_id = item.id === 'sub' ? 'sub' : 'one-time'
            let priceElement;

            if (item_id == 'sub') {
              let shipmentPrice = price - (price * priveDiscount / 100);
              let shipmentPriceWithDiscount;

              shipmentPriceWithDiscount = shipmentPrice

              priceElement = document.querySelector('[id^="subprice"]');
              setTimeout(() => {
                if(item.classList.contains('prive_type_box_active') && activeMember) {
                  ATC.textContent = `Add to cart - $${shipmentPriceWithDiscount.toFixed(2)}`;
                }
                priceElement.textContent = `$${shipmentPriceWithDiscount.toFixed(2)}`;
              }, "1");
            } else {

              let oneTimePrice = price;

              priceElement = document.querySelector('[id^="oneprice"]');
              setTimeout(() => {
                if(item.classList.contains('prive_type_box_active') && activeMember) {
                  ATC.textContent = `Add to cart - $${oneTimePrice.toFixed(2)}`;
                }
                priceElement.textContent = `$${oneTimePrice.toFixed(2)}`;
              }, "1");
            }
          })
      }

      if (activeMember) {
        theme.applyMemberDiscounts()
      }

      // const notifyMeBtn = priveWidget.parentElement.querySelector('.Notify-Me-Btn');
      // if (notifyMeBtn) {
      //   const enforceNotifyMeText = () => {
      //     notifyMeBtn.textContent = 'Notify Me';
      //   };

      //   enforceNotifyMeText();

      //   const observer = new MutationObserver(enforceNotifyMeText);
      //   observer.observe(notifyMeBtn, { childList: true, characterData: true, subtree: true });
      // }
      // if (!activeMember) {
      //   priveWidget.remove();
      // }
    }
  });

  // Move the subscription options to the top of the page
  Promise.all([
    theme.waitForElm('.prive-widget'),
    theme.waitForElm('#sub .prive_label_title'),
    theme.waitForElm('#sub .prive_input_radio'),
    theme.waitForElm('#one .prive_label_title'),
    theme.waitForElm('#one .prive_input_radio')
  ]).then(([priveWidget]) => {
    const sub = document.getElementById('sub');
    const one = document.getElementById('one');
    if (sub && one && priveWidget) {
      priveWidget.insertBefore(sub, one); // ⬅ Ensures sub is rendered first
    }
  });

  // Make the one-time option selected by default
  theme.waitForElm('#one .prive_input_radio').then(oneInput => {
    if (oneInput) {
      oneInput.checked = true;
      oneInput.click(); // this will trigger both onclick and onchange handlers
    }
    const oneBox = document.getElementById('one');
    if (oneBox) {
      document.querySelectorAll('.prive_type_box_active').forEach(el => {
        el.classList.remove('prive_type_box_active');
      });
      oneBox.classList.add('prive_type_box_active');
    }
  });

  // Lets user click anywhere on the subscription input to select it
  Promise.all([
    theme.waitForElm('#sub'),
    theme.waitForElm('#sub input.prive_input_radio')
  ]).then(([subBox, subInput]) => {
    if (subBox && subInput) {
      subBox.addEventListener('click', event => {
        // Prevent double-triggering if they click the input itself
        if (!event.target.closest('input.prive_input_radio')) {
          subInput.click(); // This runs Prive's built-in onclick + onchange
        }
      });
    }
  });
  

};

theme.waitForElm = function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
  //returns promise with element: waitForElm(targetElement).then(elem => {})
}

//************************ Cart Quantity Change ***************** */

theme.cartQuantityChange = function() {
  $('#cart_content_container').on('click','.Cart__QuantityUpdate',function(e) {
    const qtySelector = $(e.target).closest('.QuantitySelector');
    let qty = parseInt(qtySelector.find('.QuantitySelector__CurrentQuantity').val());
    let id = qtySelector.find('.QuantitySelector__Button').attr('data-line-id');
    let el = $(this);

    document.dispatchEvent(new CustomEvent('contentUpdated'));
    // Add or subtract from the current quantity
    if (el.hasClass('QuantitySelector__Button--increase')) {
      qty = qty + 1;
    } else {
      qty = qty - 1;
      if (qty <= 0) {
        qty = 0;
      }
    }
    var data = {
      [id]: qty
    };

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: {
        updates: data
      },
      success: function () {
        theme.syncSameProducts(id, qty)
        Shopify.getCart(function(cart){
          theme.rerenderCartPageBody();
        }.bind(this));
      },
      error: function (error) {
        if (error.status == 422) {
          $errorMessage.text(error.responseJSON.description).fadeIn('slow');

          setTimeout( () => {
            $errorMessage.fadeOut('slow').text('');
          }, 6000);
        }
      }
    });

  })
}
// ********************* Rerender cart page body section only **********************

theme.rerenderCartPageBody = function() {
  if (window.theme.pageType !== 'cart') {
    const cartContentContainer = $('#item-list-container');
    const cartSummaryData = $('.summary_data');
    const cartMembersOptions = $('.toggle-member-prices');
    const checkoutBtn = $('#continue_checkout');
    const backToStoreBtn = $('#back_to_store');

    const membershipOption = sessionStorage.getItem('Membership Option');

    // Free shipping elements on Cart page
    const shippingContainer = $('#cart_content_container .Cart__ShippingNotice');
    const shippingProgressLine = $('#cart_content_container .Cart__ShippingProgressLine');
    const shippingProgressBar = $('#cart_content_container .Cart__ShippingProgressBar');
    const shippingMessage = $('#cart_content_container .Cart__ShippingMessage');

    let newWidth;
    let remaining_amount;

    const nonMember = !window.activeMember && !window.membershipInCart

    fetch(window.location.pathname + "?sections=cart-body")
      .then(res => res.json())
      .then(data => {
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = data['cart-body'];
        cartContentContainer.html($(tempDiv).find('#item-list-container'));
        cartSummaryData.replaceWith($(tempDiv).find('.summary_data'));

        let newCartMembersOptions = $(tempDiv).find('.toggle-member-prices');

        if (window.location.href.indexOf('/pages/cart') > -1) {
          cartMembersOptions.replaceWith(newCartMembersOptions);
        }

        let newTotalPrice = newCartMembersOptions.data('total-price');
        let newCartTotalPrice = newCartMembersOptions.data('cart-total-price');
        let newNonMemberPrice = newCartMembersOptions.data('total-nonmember-price');
        let newCartTotalCount = newCartMembersOptions.data('cart-items-count');

        const newCheckoutBtn = $(tempDiv).find('#continue_checkout');
        const newBackToStoreBtn = $(tempDiv).find('#back_to_store');

        if (nonMember) {

          $('.CartBanner').hide();

          fetch('/?sections[]=non-member-freeshiping')
            .then(freeshippingResponse => freeshippingResponse.json())
            .then(freeShippingJSON => {
              const freeShippingHTML = freeShippingJSON['non-member-freeshiping'];

              // Create a temporary div to parse the HTML
              let tempDivNonMember = document.createElement('div');
              tempDivNonMember.innerHTML = freeShippingHTML;

              // Extract newWidth and remaining_amount from freeShippingHTML data
              newWidth = $(tempDivNonMember).find('.Cart__ShippingNotice').data('width');
              remaining_amount = $(tempDivNonMember).find('.Cart__ShippingProgressBar').data('remaining_amount');
              updateShippingProgressBarAndMessages(newCartTotalPrice);

            })
            .catch(error => {
              console.error("Error fetching non-member free shipping section:", error);
            });
        } else {
          // For members, get newWidth and remaining_amount from existing tempDiv
          newWidth = $(tempDiv).find('.Cart__ShippingNotice').data('width');
          remaining_amount = $(tempDiv).find('.Cart__ShippingProgressBar').data('remaining_amount');
          updateShippingProgressBarAndMessages(newCartTotalPrice);
        }

        // Function to update the shipping progress bar and messages - calculates based on putting free shipping in the center
        function getAdjustedProgress(cartTotal, shippingThreshold, giftThreshold, hasFreeShipping = false) {
          if (hasFreeShipping) {
            if (cartTotal >= giftThreshold) return 100;
        
            // Start at 50%, scale to 100% as cartTotal approaches gift threshold
            return 50 + (cartTotal / giftThreshold) * 50;
          }
        
          if (cartTotal <= shippingThreshold) {
            return (cartTotal / shippingThreshold) * 50;
          } else if (cartTotal >= giftThreshold) {
            return 100;
          } else {
            const remaining = giftThreshold - shippingThreshold;
            const progressPastShipping = cartTotal - shippingThreshold;
            return 50 + (progressPastShipping / remaining) * 50;
          }
        }        
        
        function updateShippingProgressBarAndMessages(cartTotal) {
          const shippingThreshold = 4500; // $45 in cents
          const giftThreshold = window.cartFreeGiftThreshold;    // $100 in cents

          const hasFreeShipping = window.hasFreeShipping === true;
          const showPromoThreshold = window.cartShowFreeShippingThreshold === true;
          const countryCode = localStorage.getItem('country_code');
        
          const shippingContainer = $('.Cart__ShippingNotice');
          const shippingMessage = $('.Cart__ShippingMessage');
          const promoMessage = $('.Cart__ShippingMessagePromo');
          const successMessage = $('.Cart__Success');
          const shippingProgressBar = $('.Cart__ShippingProgressBar');
          const shippingProgressLine = $('.Cart__ShippingProgressLine');
        
          if (countryCode === 'CA') {
            shippingContainer.hide();
            return;
          }
        
          // Determine progress
          let progressPercentage = 0;
        
          if (!showPromoThreshold) {
            // One-stage progress (only free shipping at end)
            if (cartTotal >= shippingThreshold || hasFreeShipping) {
              progressPercentage = 100;
            } else {
              progressPercentage = (cartTotal / shippingThreshold) * 100;
            }
          } else {
            // Two-stage progress (shipping at 50%, gift at 100%)
            if (hasFreeShipping) {
              if (cartTotal >= giftThreshold) {
                progressPercentage = 100;
              } else {
                progressPercentage = 50 + (cartTotal / giftThreshold) * 50;
              }
            } else {
              if (cartTotal <= shippingThreshold) {
                progressPercentage = (cartTotal / shippingThreshold) * 50;
              } else if (cartTotal >= giftThreshold) {
                progressPercentage = 100;
              } else {
                const progressPastShipping = cartTotal - shippingThreshold;
                const distance = giftThreshold - shippingThreshold;
                progressPercentage = 50 + (progressPastShipping / distance) * 50;
              }
            }
          }
        
          const amountToShipping = (shippingThreshold - cartTotal) / 100;
          const amountToGift = (giftThreshold - cartTotal) / 100;
        
          // Update progress bar
          shippingProgressLine.css('width', progressPercentage + '%');
          shippingProgressLine.attr('data-progress-line-width', progressPercentage);
          shippingProgressBar.show();
        
          // Reset messages
          shippingMessage.html('');
          promoMessage.html('');
          successMessage.html('');
        
          // Update messages
          if (!showPromoThreshold) {
            // One goal: free shipping
            if (cartTotal >= shippingThreshold || hasFreeShipping) {
              successMessage.html("YOU UNLOCKED FREE SHIPPING!");
            } else {
              shippingMessage.html(`ADD $${amountToShipping.toFixed(2)} FOR FREE SHIPPING!`);
            }
          } else {
            // Shipping + gift logic
            if (cartTotal >= giftThreshold) {
              successMessage.html("YOU UNLOCKED FREE SHIPPING & A $20 DISCOUNT!");
            } else if (hasFreeShipping || cartTotal >= shippingThreshold) {
              promoMessage.html(`YOU ARE $${amountToGift.toFixed(2)} AWAY FROM A $20 DISCOUNT!`);
            } else {
              shippingMessage.html(`ADD $${amountToShipping.toFixed(2)} FOR FREE SHIPPING!`);
            }
          }
        
          adjustTotalPriceAndCheckoutButtons();
        }            

        // Function to adjust the total price and checkout buttons
        function adjustTotalPriceAndCheckoutButtons() {
          if (!window.customer && newCartTotalPrice !== newNonMemberPrice) {
            if (membershipOption === 'Annual 69 No Trial') {
              newTotalPrice += 6900;
              $('.Cart__LabelPrice').text('$69.00');
              $('.item-and-summary-container .CartBanner .CartBanner__perks-list .CartBanner__parks-list__each:first .CartBanner__ItemText')
                .text('Access members-only prices for $69/year.');
              $('.toggle-price-info').text('Access members-only prices for $69/year.');
              $('.CartBanner__Membership-Price').text(theme.Currency.formatMoney(6900, window.theme.moneyFormat));
            } else if (membershipOption === 'Annual 65 No Trial free shipping') {
              newTotalPrice += 6500;
            }
            // $('.subtotal-price').text(theme.Currency.formatMoney(newTotalPrice, window.theme.moneyFormat));
          } else {
            if (localStorage.getItem('isVariation') == 'true') {
              $('.toggle-price-info').text('Access members-only prices for $69/year.');
            }
          }

          if (newCartTotalCount === 0) {
            if (newBackToStoreBtn.length > 0) {
              checkoutBtn.replaceWith(newBackToStoreBtn);
            }
          } else {
            if (newCheckoutBtn.length > 0) {
              // newCheckoutBtn.text('Continue to Checkout - ' + theme.Currency.formatMoney(newTotalPrice, window.theme.moneyFormat));
              backToStoreBtn.replaceWith(newCheckoutBtn);
              checkoutBtn.replaceWith(newCheckoutBtn);
            }
          }


          // Handle checkout button behavior
          $("#continue_checkout, #continue_checkout_new").on("click", function (e) {

            const $button = $(this);
            const originalButtonContent = $button.html();

            $(this).html(
              '<img src="https://cdn.shopify.com/s/files/1/0838/7991/files/loading-buffering_1.gif?v=1634317488" height="15px" width="15px">'
            );
                jQuery.getJSON('/cart.js', function (cart) {
                }).then(function (cart) {
                  let retailTotalPrice;

                  if ($("#Member_CartTotal").data("retail-price") == cart.items_subtotal_price) {
                    retailTotalPrice = sessionStorage.getItem("Membership Option") === "None"
                                      ? $("#Member_RetailPrice").data("retail-price")
                                      : $("#NonMember_RetailPrice").data("retail-price")
                  } else {
                    retailTotalPrice = sessionStorage.getItem("Membership Option") === "None"
                                      ? $("#Member_RetailPrice_Body").data("retail-price")
                                      : $("#NonMember_RetailPrice_Body").data("retail-price")
                  }

                  $.ajax({
                    type: "POST",
                    url: "/cart.js",
                    data: { attributes: { retailTotal: retailTotalPrice } },
                    dataType: "json",
                    success: function (data) {
                      $button.html(originalButtonContent);
                      window.location.href = '/checkout'
                    },
                    error: function (error) {
                      console.log("Error status: ",error.status);
                      $button.html(originalButtonContent);
                      window.location.href = "/checkout";
                    }
                  })
                })
          })
          theme.attachToggleEventListeners();
        }
      })
      .catch(error => {
        console.error("Error fetching cart body data:", error);
      });
  }
};

// ********************* Product reviews slider **********************
theme.productReviewsSlider = function () {
  var target = document.querySelector('.ProductMeta__ReviewsHighlight');
  var config = { childList: true, subtree: true };
  var $wrapperSlider = $(document).find('.ProductMeta__ReviewsHighlight');
  let productId = $wrapperSlider.data('productId');
  const query = 'per_page=100&sort=rating';
  $.get( `https://api-cdn.yotpo.com/v1/widget/1czk4hDZQU9jrmp3MaNi1wqhc05RABHrg6aDSVLd/products/${productId}/reviews.json?${query}`, function( data ) {
    const returnedReviews = data.response.reviews;
    const reviewCharLimit = 26;
    const reviewMinimumCharCount = 3;
    let filterNoHeading = [];//Hold filtered review from body text
    // console.log("REVIEW ALL:: ",returnedReviews);
    returnedReviews.forEach(review => {
      if(review.content.split('.')[0].length < reviewCharLimit && review.content.split('.')[0].length > reviewMinimumCharCount && review.score == 5){
        filterNoHeading.push(review.content.split('.')[0]);
      } else if(review.content.split('!')[0].length < reviewCharLimit && review.content.split('!')[0].length > reviewMinimumCharCount && review.score == 5) {
        filterNoHeading.push(review.content.split('!')[0])
      }
    })
    // console.log("REVIEW FILTERED:: ",filterNoHeading);
    filterNoHeading.length = 4;
    filterNoHeading.forEach(review =>$wrapperSlider.append(`<div class="swiper-slide">"${review}"</div>`));

    var reviewSlider = new Swiper('.ProductMeta__ReviewsHighlightOuter', {
          slidesPerView: 1,
          direction: 'horizontal',
          autoplay: {
            delay: 3000,
          },
          loop: true
    });
    // $wrapperSlider.append(`<div class="yotpo yotpo-reviews-carousel">${review.title}</div>`);

  // var observer = new MutationObserver(function(mutations) {
  //   let iterations = mutations.length;
  //   for(const mutation of mutations) {
  //     if (!--iterations) {
  //       let $wrapperSliderYotpo = $(document).find('.ProductMeta__ReviewsHighlight .yotpo');

  //       if ($wrapperSliderYotpo.length) {
  //         // let $reviewSlides = $('.big-version .carousel-review-title').addClass('swiper-slide');
  //         // $wrapperSlider.empty().append($reviewSlides);

  //         var reviewSlider = new Swiper('.ProductMeta__ReviewsHighlightOuter', {
  //           slidesPerView: 1,
  //           direction: "vertical",
  //           autoplay: {
  //             delay: 3000,
  //           },
  //           loop: true
  //         });
  //         observer.disconnect();
  //       }
  //     }
  //   }

  // });

  // observer.observe(target, config);

  });
}


// ********************* Quick add to card **********************
theme.quickAddToCart = function () {
  $(document).on('click', '[data-action="quick-add"]', function(evt) {
    evt.preventDefault();

    var sku = $(evt.target).data('productSku');

    var $popup = $('.BundleBuilder__Popup');

    theme.canceledMember()

    var $errorMessage = $(this).closest('.AddToCart__ErrorMessage');
    var data = {
      id: evt.target.getAttribute('data-variant-id'),
      quantity: 1
    };

    $('.BundleBuilder__PopupClose, .BundleBuilder__PopupCloseIcon').on('click', function () {
      $popup.fadeOut();
      $('html').removeClass('no-scroll');
    });

    $('.BundleBuilder__PopupSubmit').on('click', function () {
      sessionStorage.setItem('bundlePopupShown','true');
      addCurrentProduct()
      $popup.fadeOut();
    });

    if(wineVariantIdSku[sku] && sessionStorage.getItem('bundlePopupShown') === null && $popup.length){
      $popup.fadeIn();
      $('html').addClass('no-scroll');
      data =  {...data,properties:{wineSku:wineVariantIdSku[sku]}}
      return;
    }

    addCurrentProduct()

    function addCurrentProduct() {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function () {
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: data.id,
              quantity: data.quantity
            }
          }))
        },
        error: function (error) {
          if (error.status == 422) {
            $errorMessage.text(error.responseJSON.description).fadeIn('slow');

            setTimeout( () => {
              $errorMessage.fadeOut('slow').text('');
            }, 6000);
          }
        }
      });
    }
  });
}

// ********************* Promo Remove from drawer *****************
// theme.promoRemove = function () {
//   $(document).on('click','[data-action="remove-promo"]', function(evt) {
//     evt.preventDefault();
//     $(".only-one-promo").hide();
//     sessionStorage.setItem('removeCartPromo','true');

//     // var $errorMessage = $(this).closest('.AddToCart__ErrorMessage');
//     var data = {
//       id: evt.target.getAttribute('data-variant-id'),
//       quantity: 0
//     };

//     $.ajax({
//       type: 'POST',
//       url: '/cart/change.js',
//       dataType: 'json',
//       data: data,
//       success: function () {
//         //remove FreeShippingPromo from session to avoid showing free shipping copy
//         if(sessionStorage.getItem('FreeShippingPromo'))
//           sessionStorage.removeItem('FreeShippingPromo')
//         theme.rerenderCartPageBody();
//         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
//       },
//       error: function (error) {
//         if (error.status == 422) {
//           console.log(error.responseJSON.description);
//         }
//       }
//     });
//   })
// }

// ********************* Hover tabs section **********************

theme.hoverTabs = function () {
  $('.TabsWithImage__NavBtn').on('click mouseenter', function () {
    var _this = $(this);
    var index = _this.index();
    var $tab = _this.parents('.TabsWithImage__Wrapper').find('.TabsWithImage__ContentItem');

    if (_this.attr('aria-expanded') !== true) {
      _this.siblings().attr('aria-expanded', 'false');
      _this.attr('aria-expanded', 'true');
      $tab.attr('aria-expanded', 'false').eq(index).attr('aria-expanded', 'true');
    }
  });
}

// ********************* Age verification ************************

theme.ageVerification = function () {
  //each changes in date will run followling check function
  $(document).on('change', '#dob-container input', function() {
    let day = $("#dob-container #day").val()
      ? $("#dob-container #day").val()
      : 00;
    let month = $("#dob-container #month").val()
      ? $("#dob-container #month").val()
      : 00;
    let year = $("#dob-container #year").val()
      ? $("#dob-container #year").val()
      : 0000;
    const dob = new Date(year, parseInt(month) - 1, day);
    const today = new Date();

    const currentAge = today - dob;
    const dayMillisecond = 86400000;
    $("#age-confirm").data("over-age", false);

    checkDay(day, month, year);
    checkMonth(month);
    checkYear(year);

    if (checkDay(day, month, year) && checkMonth(month) && checkYear(year)) {
      if (currentAge / dayMillisecond > 7670) {
        if (day != 00 && month != 00 && year != 0000) {
          $("#age-confirm").data("over-age", true);
          $("#age-confirm").data("dob", day + "." + month + "." + year);
        }
      } else {
        $("#warning-under-age").css("color", "red");
      }
    }
  });

  $(document).on('click touchend', '#close-age-confirm', function(evt) {
    evt.preventDefault();
    $('#age-confirm').fadeOut()
  })

  function checkDay(day, month, year) {
    day != "00"
      ? $("#dob-container #day").css("border", "none")
      : $("#dob-container #day").css("border", "1px solid #FF0505");

    if (parseInt(month) != 2) {
      if (parseInt(day) <= 31 && parseInt(day) > 0) {
        $("#dob-container #day").css("color", "black");
        return true;
      } else {
        $("#dob-container #day").css("color", "red");
        return false;
      }
    } else {
      if (parseInt(day) <= 28 && parseInt(day) > 0) {
        $("#dob-container #day").css("color", "black");
        return true;
      } else if (isLeapYear(parseInt(year)) && parseInt(day) == 29) {
        $("#dob-container #day").css("color", "black");
        return true;
      } else {
        $("#dob-container #day").css("color", "red");
        return false;
      }
    }
  };

  function checkMonth(month) {
    month != "00"
      ? $("#dob-container #month").css("border", "none")
      : $("#dob-container #month").css("border", "1px solid #FF0505");

    if (parseInt(month) <= 12 && parseInt(month) > 0) {
      $("#dob-container #month").css("color", "black");
      return true;
    } else {
      $("#dob-container #month").css("color", "red");
      return false;
    }
  };

  function checkYear(year) {
    const currentYear = new Date().getFullYear();
    year != "0000"
      ? $("#dob-container #year").css("border", "none")
      : $("#dob-container #year").css("border", "1px solid #FF0505");

    if (
      parseInt(year) < currentYear &&
      year.length == 4 &&
      parseInt(year) > 1900
    ) {
      $("#dob-container #year").css("color", "black");
      return true;
    } else {
      $("#dob-container #year").css("color", "red");
      return false;
    }
  };

  function isLeapYear(year) {
    return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
  }
};

//********************** Click 'Checkout' drawer******************

theme.drawerCheckout = function(evt) {
  $(document).on('click touchend', '.Cart__Checkout', function(evt) {
    evt.preventDefault();
    if($(evt.target).attr('disabled')) return;
    $(evt.target).focus();

     // Store the original button content before replacing it
    const originalButtonContent = $(".Cart__Checkout").html();
    // Replace button content with loading gif
    $(".Cart__Checkout").html(
      '<img src="https://cdn.shopify.com/s/files/1/0838/7991/files/loading-buffering_1.gif?v=1634317488" height="15px" width="15px">'
    );

    let screenSize = window.innerWidth < 500 ? 'mobile' : 'desktop';

    const retailTotalPrice = sessionStorage.getItem("Membership Option") === "None"
      ? $('#Cart__TotalPrice').attr('data-member-total')
      : $('#Cart__TotalPrice').attr('data-retail-total')

    $.ajax({
      type: "POST",
      url: "/cart.js",
      data: { attributes: { retailTotal: retailTotalPrice, screen_size: screenSize} },
      dataType: "json",
      success: function (data) {

        // Restore the original button content
        $(".Cart__Checkout").html(originalButtonContent);

        if (activeMember) {
          window.location.href = "/checkout";
        } else {
          window.location.href = "/checkout";
        }
      },
      error: function (error) {
        console.log("Error status: ",error.status);

        // Restore the original button content
        $(".Cart__Checkout").html(originalButtonContent);

        if (activeMember) {
          window.location.href = "/checkout";
        } else {
          window.location.href = "/pages/cart";
        }
      }
    });
  });
}

// ********************* Bundle builder **********************

theme.bundleBuilder = function () {
  var $bundleContainer = $('.BundleBuilder');

  if ($bundleContainer.length) {
    var $headingDefault = $('.BundleBuilder__Heading--Default'),
        $headingActive = $('.BundleBuilder__Heading--Active'),
        bundleSize = parseInt($bundleContainer.attr('data-bundle-size')),
        $totalAddedItems = $bundleContainer.find('.BundleBuilder__AddedItems .TotalAddedItems'),
        $quantitySelectors = $bundleContainer.find('.QuantitySelector__CurrentQuantity'),
        $addToCartBtn = $bundleContainer.find('.BundleBuilder__FooterButton'),
        $errorMessage = $bundleContainer.find('.AddToCart__ErrorMessage'),
        $popup = $('.BundleBuilder__Popup');

    if ($('.BundleBuilder__FooterMobile').length) {
      document.documentElement.style.setProperty('--bundle-fixed-footer', document.querySelector('.BundleBuilder__FooterMobile').offsetHeight + 'px');
    }

    function totalQuantityAndPrice () {
      var $quantityPlus = $bundleContainer.find('.QuantitySelector__Button--increase'),
          $subtotalPrice = $bundleContainer.find('.Subtotal'),
          totalQuantity = 0,
          totalPrice = 0;

      $quantitySelectors.each(function () {
        var itemQuantity = parseInt($(this).val());
        var itemPrice = parseInt($(this).parents('.BundleBuilder__Product').attr('data-product-price'));

        totalQuantity = totalQuantity + itemQuantity;
        totalPrice = totalPrice + itemQuantity * itemPrice;
      })

      // disable plus btn and add to cart btn
      if (totalQuantity >= bundleSize) {
        $quantityPlus.attr('disabled', 'true');
        $addToCartBtn.removeAttr('disabled');
      } else {
        $quantityPlus.removeAttr('disabled', 'true');
        $addToCartBtn.attr('disabled', "true");
      }

      // changing title on page
      if ($headingActive.length) {
        if (totalQuantity > 0 ) {
          $headingDefault.hide();
          $headingActive.show();
        } else {
          $headingDefault.show();
          $headingActive.hide();
        }
      }

      $totalAddedItems.html(totalQuantity);
      $subtotalPrice.html(theme.Currency.formatMoney(totalPrice, window.theme.moneyFormat));
    }

    function buildBundleData () {
      var bundleData = [];
      var uniqId = Date.now() + Math.random();

      $quantitySelectors.each(function () {
        var itemQuantity = parseInt($(this).val());
        var itemId = $(this).parents('.BundleBuilder__Product').attr('data-product-id');

        if (itemQuantity > 0) {
          var bundleItem = {
            quantity: itemQuantity,
            id: itemId,
            properties: {
              'bundle': itemQuantity,
              'caseId': uniqId
            }
          }
          bundleData.push(bundleItem);
        }
      })

      return bundleData;
    }

    function bundleAddToCart () {
      var data = buildBundleData();

      if (data) {
        if(sessionStorage.getItem('bundlePopupShown') === null && $('.BundleBuilder__Popup').length){
          $popup.fadeIn();
          $('html').addClass('no-scroll');
        } else {
          $('html').removeClass('no-scroll');

          $.ajax({
            type:'POST',
            url:'/cart/add.js',
            data: { items:data },
            dataType: 'json',
            success: function(data) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
              $addToCartBtn.html("Added");
              setTimeout(function(){
                $addToCartBtn.html("Add To Cart");
              }, 3000);

            },
            error: function (error) {
              if (error.status == 422) {
                $errorMessage.text(error.responseJSON.description).fadeIn('slow');

                setTimeout( () => {
                  $errorMessage.fadeOut('slow').text('');
                }, 6000);
              }
            }
          })
        }
      }
    }

    function mobileBundleList(event) {
      var _this = $(event.target),
          productItem = _this.parents('.BundleBuilder__Product'),
          productTitle = productItem.attr('data-product-title'),
          productId = productItem.attr('data-product-id'),
          itemList,
          itemListTitle;

      if (_this.hasClass('QuantitySelector__Button--increase')) {
        itemList = $('.BundleBuilder__ProductsListItem.Empty').first();
        itemListTitle = $('.BundleBuilder__ProductsListItem.Empty .BundleList__Title').first();

        itemListTitle.html(productTitle);
        itemList.removeClass('Empty');
        itemList.attr('data-bundle-list-id', productId);

      } else if (_this.hasClass('QuantitySelector__Button--decrease')) {
        itemList = $(`.BundleBuilder__ProductsListItem[data-bundle-list-id=${productId}]`).not('.Empty').last();
        itemListTitle = itemList.find('.BundleList__Title');

        itemListTitle.empty();
        itemList.addClass('Empty');
        itemList.attr('data-bundle-list-id', '');
      }

    }

    $('.BundleBuilder__Quantity').on('click', function (event) {
      totalQuantityAndPrice();
      mobileBundleList(event);
    });

    $('.BundleBuilder__FooterButton').on('click', bundleAddToCart);

    $('.BundleBuilder__PopupSubmit').on('click', function () {
      sessionStorage.setItem('bundlePopupShown','true');
      bundleAddToCart();
      $popup.fadeOut();
    });

    $('.BundleBuilder__PopupClose, .BundleBuilder__PopupCloseIcon').on('click', function () {
      $popup.fadeOut();
      $('html').removeClass('no-scroll');
    });

    $('.BundleList__Button').on('click', function () {
      var productId = $(this).parents('.BundleBuilder__ProductsListItem').attr('data-bundle-list-id');
      var productItemQuantity = $(`.BundleBuilder__Product[data-product-id=${productId}]`).find('.QuantitySelector__Button--decrease');
      if (productItemQuantity.length) {
        productItemQuantity.trigger('click');
      }
    })
  }
}

$(document).ready(function () {

  //************ Update selected variant to member variant when member pricing is active ************

  if (typeof window.customer !== 'undefined' && window.customer.loggedIn && sessionStorage.getItem('Membership Option') == null) {
    var url = new URL(window.location.href);

    if (sessionStorage.getItem('variantUpdated') === null) {
      const memberVariantInput = document.querySelector('input.member-variant');

      if (memberVariantInput) {
        const memberVariantId = memberVariantInput.value;
        const currentVariantId = url.searchParams.get('variant');

        if (currentVariantId !== memberVariantId) {
          url.searchParams.set('variant', memberVariantId);
          window.history.replaceState({}, document.title, url.pathname + "?" + url.searchParams.toString());

          sessionStorage.setItem('variantUpdated', 'true');

          window.location.reload();
        }
      }
    }
  }

  //********************* Aos init *****************
  if (window.AOS) {
    AOS.init({
      once: true,
      mirror: true,
      offset: 0,
      disable: function() {
        var maxWidth = 800;
        return window.innerWidth < maxWidth;
      }});
  }
  //Tracking need to call first to capture UTM
  theme.attachLandingURL();
  if (!window.location.href.includes('search')) {
    theme.moveCollectionCtaMobile();
  }
  theme.bundleBuilder();
  theme.reorder();
  theme.listenCartObjChange(); //Disable upsell by commenting this line of code
  theme.productCard();
  theme.subOptChange();
  theme.backinstockPopup();
  theme.scrollBannerAdjust();
  // theme.updateMembershipStatus();
  theme.tabsFunction('.ProductFeaturesTabs','.ProductFeaturesTabs__NavItem', '.ProductFeaturesTabs__ContentItem' );
  theme.removeCartItem();
  theme.checkUrlForFreeGift();
  theme.updateProductMemberPrice();
  theme.memberStatusActiveAfterLogoutOrLogin();
  theme.attachToggleEventListeners();
  if (activeMember) {
    theme.removeMembershipProduct()
  } else {
    theme.resetMembership()
  }
  // theme.promoRemove(); //Not need as removeCartitem() handle both promo and regular item
  theme.quickAddToCart();
  theme.hoverTabs();
  theme.quantitySelector();
  theme.ariaToggleSlide();
  theme.drawerCheckout();
  theme.sortIcon();
  theme.cartQuantityChange();
  theme.preselectSub();
  theme.infoPopupLogic();
  theme.hideselectSub();
  if (window.location.href.indexOf('/pages/cart') > -1) { theme.rerenderCartPageBody(); }
  theme.memberPopupLogic();

  if (window.theme.pageType === 'product') {
    if ($('.ProductMeta__ReviewsHighlight').length) {
      theme.productReviewsSlider();
    }
  }

  //********************** Announcement Cross/close ************ */

  $('.AnnouncementBar__cross').click(()=>{
    $('.AnnouncementBar').hide()
    sessionStorage.setItem("emailBannerClosed", "true")
  })

  // This code allow users to slider variant selection inside a flickity slider
  setTimeout(() => {
    document.querySelectorAll('.flickity-enabled').forEach(sliderEl => {
      const flkty = Flickity.data(sliderEl);
      if (!flkty) return;
  
      sliderEl.querySelectorAll('.ProductCard__Variants').forEach(scrollEl => {
        let isDragging = false;
        let startX = 0;
        let startScrollLeft = 0;
        let hasMoved = false;
  
        const canScroll = () => scrollEl.scrollWidth > scrollEl.clientWidth;
  
        // Prevent Flickity drag only for this element
        ['touchstart', 'mousedown', 'pointerdown'].forEach(eventType => {
          scrollEl.addEventListener(eventType, (e) => {
            if (canScroll()) {
              e.stopPropagation();
            }
          }, { passive: true });
        });
  
        // ----- DESKTOP drag-to-scroll -----
        scrollEl.addEventListener('mousedown', (e) => {
          if (!canScroll()) return;
  
          isDragging = true;
          hasMoved = false;
          startX = e.pageX;
          startScrollLeft = scrollEl.scrollLeft;
  
          scrollEl.classList.add('is-dragging');
          scrollEl.style.userSelect = 'none';
          scrollEl.style.cursor = 'grabbing';
  
          e.preventDefault();
        });
  
        scrollEl.addEventListener('mousemove', (e) => {
          if (!isDragging) return;
  
          const dx = e.pageX - startX;
          if (Math.abs(dx) > 5) hasMoved = true;
          scrollEl.scrollLeft = startScrollLeft - dx;
        });
  
        scrollEl.addEventListener('mouseup', () => {
          isDragging = false;
          scrollEl.classList.remove('is-dragging');
          scrollEl.style.userSelect = '';
          scrollEl.style.cursor = 'grab';
        });
  
        scrollEl.addEventListener('mouseleave', () => {
          if (isDragging) {
            isDragging = false;
            scrollEl.classList.remove('is-dragging');
            scrollEl.style.userSelect = '';
            scrollEl.style.cursor = 'grab';
          }
        });
  
        // ----- TOUCH drag-to-scroll -----
        scrollEl.addEventListener('touchstart', (e) => {
          if (!canScroll()) return;
  
          isDragging = true;
          hasMoved = false;
          startX = e.touches[0].pageX;
          startScrollLeft = scrollEl.scrollLeft;
  
          e.stopPropagation();
        }, { passive: true });
  
        scrollEl.addEventListener('touchmove', (e) => {
          if (!isDragging) return;
  
          const dx = e.touches[0].pageX - startX;
          if (Math.abs(dx) > 5) hasMoved = true;
          scrollEl.scrollLeft = startScrollLeft - dx;
  
          e.stopPropagation();
        }, { passive: true });
  
        scrollEl.addEventListener('touchend', () => {
          isDragging = false;
        });
  
        // ----- Prevent accidental click after drag -----
        scrollEl.addEventListener('click', (e) => {
          if (hasMoved) {
            e.preventDefault();
            e.stopImmediatePropagation();
            hasMoved = false;
          }
        }, true);
      });
    });
  }, 0); // You can increase delay if DOM isn't fully loaded

  // Below code is for hiding/showing available/unavailable variants on the pdps
  if (window.location.href.includes("/products")) {
    function initVariantFiltering() {
      // Only run on pages with product variants
      if (!window.productVariants || !document.querySelector('.ProductForm__Variants')) {
        return;
      }
      
      // Get available sizes for a selected fragrance option
      function getAvailableSizes(selectedFragrance) {
        return window.productVariants
          .filter(variant => variant.option1 === selectedFragrance && variant.available)
          .map(variant => variant.option2)
          .filter((size, index, arr) => arr.indexOf(size) === index); // Remove duplicates
      }
      
      // Show/hide size options based on availability
      function toggleSizeOptions(availableSizes) {
        // Find all size option containers (option-1 should be sizes)
        const sizeOptions = document.querySelectorAll('input[name="option-1"]');
        
        sizeOptions.forEach(input => {
          const sizeValue = input.value;
          const listItem = input.closest('.HorizontalList__Item');
          
          if (availableSizes.includes(sizeValue)) {
            // Show available options
            if (listItem) {
              listItem.style.display = '';
              listItem.classList.remove('unavailable');
            }
            input.disabled = false;
          } else {
            // Hide unavailable options
            if (listItem) {
              listItem.style.display = 'none';
              listItem.classList.add('unavailable');
            }
            input.disabled = true;
            
            // Uncheck if currently selected
            if (input.checked) {
              input.checked = false;
            }
          }
        });
        
        // Count visible size options and adjust alignment
        const sizeList = document.querySelector('.SizeSwatchList');
        if (sizeList) {
          const visibleItems = sizeList.querySelectorAll('.HorizontalList__Item:not([style*="display: none"])');
          const hiddenItems = sizeList.querySelectorAll('.HorizontalList__Item[style*="display: none"]');
          
          if (visibleItems.length === 1) {
            sizeList.style.justifyContent = 'flex-start';
          } else {
            sizeList.style.justifyContent = 'center';
          }
        }
        
        // Auto-select first available size if none selected
        const checkedSize = document.querySelector('input[name="option-1"]:checked');
        if (!checkedSize && availableSizes.length > 0) {
          const firstAvailable = document.querySelector(`input[name="option-1"][value="${availableSizes[0]}"]`);
          if (firstAvailable && !firstAvailable.disabled) {
            firstAvailable.checked = true;
            // Trigger change event to update prices
            firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
      
      // Listen for fragrance option changes (assuming fragrance is option-0)
      const productForm = document.querySelector('.ProductForm__Variants');
      if (!productForm) return;
      
      productForm.addEventListener('change', function(e) {
        // Check if it's a fragrance option change
        if (e.target.name === 'option-0' && e.target.type === 'radio') {
          const selectedFragrance = e.target.value;
          const availableSizes = getAvailableSizes(selectedFragrance);
          toggleSizeOptions(availableSizes);
        }
      });
      
      // Initialize on page load with currently selected fragrance
      const selectedFragrance = productForm.querySelector('input[name="option-0"]:checked');
      if (selectedFragrance) {
        const availableSizes = getAvailableSizes(selectedFragrance.value);
        toggleSizeOptions(availableSizes);
      }
    }

    // Initialize when DOM is ready
    initVariantFiltering();

    // Optional: Add CSS for smooth transitions
    const style = document.createElement('style');
    style.textContent = `
      .SizeSwatchList .HorizontalList__Item {
        transition: opacity 0.3s ease;
      }
      
      .SizeSwatchList .HorizontalList__Item.unavailable {
        opacity: 0.3;
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);

    document.querySelectorAll('.SizeSwatchList').forEach(list => {
      const visibleItems = Array.from(list.children).filter(li => {
        return window.getComputedStyle(li).display !== 'none';
      });
    
      if (visibleItems.length === 1) {
        list.classList.add('only-one-visible');
      } else {
        list.classList.remove('only-one-visible');
      }
    });
  }

});
